/*
 * ep-konf-suite.js — gemeinsame Funktionen aller Englputzeder-Konfiguratoren
 *
 * 22.10.2026 (U0): Portierung von my-Harry assets/mh-konf-suite.js fuer Englputzeder
 * (Theme Enterprise 1.4.2). Gleiche globale API (window.MHKonf / window.MHKonfQ), damit die
 * Konfiguratoren unveraendert andocken. Aenderungen gegenueber my-Harry:
 *  - Konfiguration aus window.EP_KONF_CFG (snippets/ep-konf-config.liquid): Kurzlink-Worker (link),
 *    Live/Feedback-Worker (live), Klaviyo company + Listen (leer = Klaviyo aus), Termin-Link.
 *    Keine my-Harry-IDs/-Endpunkte mehr im Code.
 *  - Warenkorb-Selektoren Enterprise: Positionen tr.cart-item[id^="cart-item-"] (Drawer + /cart),
 *    "Planung bearbeiten" oben in .cart-drawer__summary bzw. #cart-summary.
 *  - refreshCart: dispatch:cart-drawer:refresh + dispatch:cart-drawer:open (zusaetzlich
 *    cart:refresh fuer Altcode; die Bruecke in snippets/ep-konf-bridge.liquid uebersetzt es ebenfalls).
 *  - Texte in Sie-Form, Marke Englputzeder, de-AT, PLZ 4-stellig (AT), Telefon +43,
 *    Kontakt anfrage@englputzeder.at, Farben EP (#B0101C / Hover #8A0C16 / hell #FBECEC).
 *  - Badge-Links auf die neuen Seiten-Handles, Feedback-Auswahl um Pergola ergaenzt.
 *  - Keine VIP-/BD-Sale-Teile (MH_KONF_SALE, vip-konf.js) mehr.
 *
 * Urspruengliche Funktionsliste (my-Harry, 29.09.2026):
 *
 *  1. Beratungs-Hinweis: nach 60 s ohne Eingabe in einem offenen Konfigurator erscheint
 *     einmal pro Besuch ein Hinweis mit Link zur Terminbuchung.
 *  2. Kennung: jede Warenkorb-Position aus einem Konfigurator bekommt die versteckte
 *     Eigenschaft _konfigurator, der Warenkorb zusaetzlich das Attribut "Konfigurator".
 *     Daran haengt der Shopify-Flow das Bestell-Tag "Konfigurator".
 *  3. Speichern & teilen: E-Mail + PLZ, Eintrag in die Klaviyo-Liste des Konfigurators,
 *     Ereignis "Konfiguration gespeichert" mit Link; danach Link teilen per WhatsApp,
 *     E-Mail, Kopieren oder Weiterleiten (Teilen-Menue des Geraets).
 *  4. Wiederherstellen: ein geteilter Link (?konf=...) oeffnet den Konfigurator - auch im
 *     PopUp der Produktseite - und stellt die Planung wieder her.
 *  5. i-Symbole: MHKonf.info(el) kuerzt lange Hilfetexte auf eine Zeile + Info-Symbol.
 *  6. Planung exportieren (29.09.2026): vor dem PDF wird die E-Mail-Adresse abgefragt
 *     (seit 13.10.2026 freiwillig), das Newsletter-Haekchen ist freiwillig. Karten-Reihenfolge in allen vier
 *     Konfiguratoren: 1 Planung exportieren, 2 Speichern & teilen, 3 Lieber persoenlich?
 *  7. Feedback abgeben (30.09.2026): vierte Karte in allen Konfiguratoren, PopUp mit sechs
 *     kurzen Fragen. Antworten gehen an den Cloudflare-Worker (POST /feedback), der sie
 *     speichert; Auswertung unter <Worker>/feedback/auswertung. Dieselbe Umfrage steht als
 *     Seite unter ?view=feedback (MHKonf.feedbackInline). Anonym, ausser der Kunde gibt
 *     freiwillig E-Mail und/oder Telefon fuer Rueckfragen an (seit 30.09.: Telefon, "bereits bestellt").
 *  8. Klaviyo-Ereignisse aller vier Karten (30.09.2026):
 *       "Planung exportiert"        - Karte 1 (E-Mail Pflicht)
 *       "Konfiguration gespeichert" - Karte 2 (E-Mail Pflicht)
 *       "Beratung angeklickt"       - Karte 3 und Beratungs-Hinweis; mit der zuletzt im Konfigurator
 *                                     genannten E-Mail, sonst ueber klaviyo.js (nur bekannte Besucher)
 *       "Konfigurator Feedback"     - Karte 4, nur wenn im Feedback eine E-Mail angegeben wurde
 *     Test: window.MH_KLAVIYO_TEST = function (path, body) {...} ersetzt jeden Versand an Klaviyo.
 *     13.10.2026 Sicherheits-Review: Ereignisse nur mit Marketing-Einwilligung (marketingOk:
 *     Cookiebot bzw. Shopify Customer Privacy API), "Beratung angeklickt" ohne E-Mail; Listen-
 *     Eintrag nur ueber das Newsletter-Haekchen. Kurzlink/PDF/Feedback laufen ohne Klaviyo.
 *
 *  9. Speichern mit Name + Beschreibung (30.09.2026, beides freiwillig, steckt im Link als _m).
 * 10. Planung bearbeiten aus dem Warenkorb (30.09.2026): jede Konfigurator-Position bekommt
 *     _mh_id und _mh_link. Im Warenkorb (Drawer + Seite) steht je Planung "Planung bearbeiten".
 *     Wer ueber diesen Link zurueckkommt und erneut in den Warenkorb legt, ersetzt die alten
 *     Positionen dieser Planung (mhre=<_mh_id>).
 * 11. Mini-Vorschau (30.09.2026): scrollt die grosse Vorschau aus dem Bild, bleibt unten rechts
 *     ein kleines Bild der Konfiguration stehen (Tippen springt zurueck).
 * 12. Kopfzeile wie beim WPC-Konfigurator (30.09.2026) fuer Sichtschutz und Doppelstab:
 *     Produkt, Eckdaten, Preis und die 3D/AR/Live-Knoepfe in einer Karte ueber der Vorschau.
 * 13. "Dein Set steht" (30.09.2026) in allen vier: Preis, Streichpreis, Ersparnis zur UVP,
 *     Aktions-Hinweis (window.MH_KONF_AKTION aus snippets/mh-konf-aktion.liquid), die
 *     wichtigsten Positionen und "Stueckliste anzeigen" zum Aufklappen.
 *
 * 18. Automatisches Speichern am letzten Schritt (28.10.2026): anonyme Konfiguration (ohne E-Mail,
 *     PLZ, Name) an POST {EP_KONF_CFG.snap|link}/snap, entprellt + dedupliziert; "In den Warenkorb" setzt in_cart.
 *     Pergola meldet sich per Event 'mh:konf:final' (assets/ep-pergola.js). Test: window.MH_SNAP_TEST.
 *
 * Die Konfiguratoren melden sich selbst an:
 *   (window.MHKonfQ = window.MHKonfQ || []).push(['wpc', { ready, serialize, restore }]);
 * Klaviyo wird ueber die oeffentliche Client-API angesprochen (company_id ist der
 * oeffentliche Site-Schluessel, kein Geheimnis).
 */
(function () {
  'use strict';
  if (window.MHKonf) return;

  /* 22.10.2026 (EP): alle Kennungen/Endpunkte aus window.EP_KONF_CFG - leer = Funktion aus */
  var CFG = window.EP_KONF_CFG || {};
  var KL = CFG.klaviyo || {};
  var KL_LISTS = KL.lists || {};
  var KLAVIYO_COMPANY = String(KL.company || '').trim();
  var KLAVIYO_REVISION = '2025-07-15';
  var TERMIN_URL = String(CFG.termin || 'https://termin.englputzeder.at/englputzeder');
  var KONTAKT = 'anfrage@englputzeder.at';
  var IDLE_MS = 60000;

  var KONF = {
    wpc:        { name: 'WPC-Dielen',           was: 'Ihre Terrasse',   list: String(KL_LISTS.wpc || ''),        root: '#mhWpcRoot', modal: 'mhwkModal', open: 'mhwkOpen', card: '.extras' },
    terrassen:  { name: 'Terrassenplatten',     was: 'Ihre Terrasse',   list: String(KL_LISTS.terrassen || ''),  root: '#mhKonfRoot', modal: 'mhtkModal', open: 'mhtkOpen', card: '.extras' },
    zaun:       { name: 'Sichtschutzzaun',      was: 'Ihren Zaun',      list: String(KL_LISTS.zaun || ''),       root: '.mhzk-app',  modal: 'mhzkModal', open: 'mhzkOpen', card: '.mhzk-extras' },
    doppelstab: { name: 'Doppelstabmattenzaun', was: 'Ihren Zaun',      list: String(KL_LISTS.doppelstab || ''), root: '.mhds-app',  modal: 'mhdsModal', open: 'mhdsOpen', card: '.mhds-extras' }
  };
  var KEYS = Object.keys(KONF);
  var adapters = {};

  /* ---------- kleine Helfer ---------- */
  function ls(k, v) {
    try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function ss(k, v) {
    try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }
  /* 13.10.2026: Sicherheits-Review – E-Mail/PLZ nur zum Vorausfuellen der Formulare, mit Zeitstempel,
     verfallen nach 90 Tagen (alte Werte ohne Zeitstempel werden verworfen). */
  function lsT(k, v) {
    if (v !== undefined) return ls(k, v + '|' + Date.now());
    var s = ls(k) || '', i = s.lastIndexOf('|');
    if (i > 0 && Date.now() - (+s.slice(i + 1)) < 7776e6) return s.slice(0, i);
    try { window.localStorage.removeItem(k); } catch (e) {}
    return '';
  }
  /* 13.10.2026: Sicherheits-Review – Marketing-Einwilligung (Cookiebot, sonst Shopify Customer Privacy API).
     Ohne Consent-Tool gibt es kein Tracking. */
  function marketingOk() {
    try {
      var cb = window.Cookiebot, sp = window.Shopify && window.Shopify.customerPrivacy;
      if (cb && cb.consent && cb.consent.marketing === true) return true;
      if (sp && typeof sp.marketingAllowed === 'function') return sp.marketingAllowed() === true;
    } catch (e) {}
    return false;
  }
  /* 13.10.2026: Sicherheits-Review – Links aus Warenkorb-Eigenschaften (_mh_link) nur rendern, wenn sie
     auf diese Seite (gleiche Origin, https) zeigen; sonst null. */
  function safeLink(u) {
    if (!u) return null;
    try {
      var x = new URL(String(u), window.location.origin);
      var lh = x.protocol === 'http:' && /^(localhost|127\.0\.0\.1)$/.test(x.hostname);
      return x.origin === window.location.origin && (x.protocol === 'https:' || lh) ? x.href : null;
    } catch (e) { return null; }
  }
  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function rootOf(k, needVisible) {
    var list = document.querySelectorAll(KONF[k].root);
    for (var i = 0; i < list.length; i++) if (!needVisible || shown(list[i])) return list[i];
    return null;
  }
  function active() {
    for (var i = 0; i < KEYS.length; i++) {
      var r = rootOf(KEYS[i], true);
      if (r) return { key: KEYS[i], root: r, c: KONF[KEYS[i]] };
    }
    return null;
  }
  function keyOf(el) {
    if (!el || !el.closest) return null;
    for (var i = 0; i < KEYS.length; i++) if (el.closest(KONF[KEYS[i]].root)) return KEYS[i];
    return null;
  }

  /* ---------- CSS ---------- */
  var CSS =
    /* i-Symbol mit Hinweis (auch fuer Texte in den Konfiguratoren selbst) */
    /* 29.09.2026: mit !important - Konfigurator-Styles wie ".toggle div span{display:block}" oder
       ".mhds-card span{...}" trafen sonst auch das i und den Hinweis (Hinweis dauerhaft offen, i verschoben). */
    '.mhk-i{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;vertical-align:middle!important;width:18px!important;height:18px!important;min-width:18px!important;padding:0!important;margin:-2px 0 0 6px!important;border-radius:50%!important;border:1px solid #cfc7ba!important;background:#fff!important;color:#6f685f!important;font:700 italic 11px/1 Georgia,serif!important;text-indent:0!important;letter-spacing:0!important;text-transform:none!important;box-sizing:border-box!important;cursor:help;user-select:none;flex:none!important}' +
    '.mhk-i:hover,.mhk-i:focus,.mhk-i.is-open{border-color:#B0101C!important;color:#8A0C16!important;outline:none}' +
    '.mhk-i__tip{position:absolute!important;left:50%;bottom:calc(100% + 8px);transform:translateX(-50%)!important;z-index:30!important;width:260px!important;max-width:78vw!important;height:auto!important;display:none!important;padding:10px 12px!important;margin-top:0!important;margin-bottom:0!important;border:0!important;border-radius:10px!important;background:#231f20!important;color:#fff!important;font:400 12px/1.45 var(--body-font-family,var(--font-body-family,Inter)),sans-serif!important;font-style:normal!important;text-align:left!important;box-shadow:0 6px 20px rgba(35,31,32,.28);cursor:default;white-space:normal!important;letter-spacing:normal!important;text-transform:none!important}' +
    '.mhk-i__tip b{display:block!important;font-weight:700!important;font-size:12px!important;color:#fff!important;margin:0 0 4px!important}' +
    '.mhk-i:hover .mhk-i__tip,.mhk-i:focus .mhk-i__tip,.mhk-i.is-open .mhk-i__tip{display:block!important}' +
    '.mhk-i--down .mhk-i__tip{bottom:auto;top:calc(100% + 8px)}' +
    /* Overlays */
    '.mhks-ov{position:fixed;inset:0;z-index:100003;background:rgba(27,27,25,.55);display:flex;align-items:center;justify-content:center;padding:18px;font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif}' +
    '.mhks-box{position:relative;background:#FBFAF7;border-radius:18px;max-width:460px;width:100%;padding:24px 22px 20px;box-shadow:0 18px 60px rgba(0,0,0,.28);color:#1B1B19;box-sizing:border-box;text-align:left;max-height:94vh;overflow:auto}' +
    '.mhks-box *{box-sizing:border-box}' +
    '.mhks-t{display:block;font-size:19px;font-weight:700;margin:0 40px 6px 0;letter-spacing:-.01em;line-height:1.25}' +
    '.mhks-p{font-size:13.5px;line-height:1.5;color:#5E5E59;margin:0 0 14px}' +
    '.mhks-l{display:block;font-size:12px;font-weight:700;color:#1B1B19;margin:0 0 5px}' +
    '.mhks-row{display:grid;grid-template-columns:1fr 120px;gap:10px}' +
    '.mhks-ov .mhks-in{display:block;width:100%;height:auto;margin:0 0 12px;padding:12px 14px;font-size:15px;font-family:inherit;color:#1B1B19;background:#fff;border:1.5px solid #D7D3CA;border-radius:11px;outline:none;box-shadow:none}' +
    '.mhks-ov .mhks-in:focus{border-color:#B0101C}' +
    '.mhks-c{display:flex;gap:9px;align-items:flex-start;font-size:12px;line-height:1.5;color:#5E5E59;background:#FBECEC;border-radius:11px;padding:10px 12px;margin:0 0 12px;cursor:pointer}' +
    '.mhks-c input{margin:2px 0 0;flex:none;width:16px;height:16px;accent-color:#B0101C}' +
    '.mhks-c a{color:#8A0C16;text-decoration:underline}' +
    '.mhks-err{display:none;font-size:12.5px;color:#B71C1C;font-weight:600;margin:0 0 10px}' +
    '.mhks-err.on{display:block}' +
    '.mhks-ov .mhks-go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;height:auto;min-height:0;margin:0;padding:13px 18px;border:0;border-radius:11px;background:#B0101C;color:#fff;font-size:15px;font-weight:700;font-family:inherit;cursor:pointer;text-transform:none;letter-spacing:normal;text-decoration:none;line-height:1.2}' +
    '.mhks-ov .mhks-go:hover{background:#8A0C16;color:#fff}' +
    '.mhks-ov .mhks-go svg{width:20px!important;height:20px!important;min-width:0;max-width:20px;flex:none;display:block}' +
    '.mhks-l small{font-weight:400;color:#8A8A82}' +
    '.mhks-ov textarea.mhks-in{min-height:64px;resize:vertical;line-height:1.45}' +
    /* 10. Planung bearbeiten im Warenkorb */
    '.mhks-editbox{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 8px}.mhks-editbox .mhks-edit{margin:0}' +
    '.mhks-edit{display:inline-flex;align-items:center;gap:6px;margin:6px 0 0;padding:6px 11px;border:1.5px solid #B0101C;border-radius:999px;background:#FBECEC;color:#8A0C16!important;font-size:12.5px;font-weight:700;line-height:1.2;text-decoration:none!important;width:max-content;max-width:100%}' +
    '.mhks-edit:hover{background:#B0101C;color:#fff!important}' +
    '.mhks-edit svg{width:14px;height:14px;flex:none}' +
    '.mhks-toast{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:100004;max-width:min(92vw,520px);background:#1B1B19;color:#fff;border-radius:14px;padding:12px 16px;font-size:13.5px;line-height:1.45;box-shadow:0 10px 30px rgba(0,0,0,.3);font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif}' +
    '.mhks-toast b{display:block;font-size:14px}.mhks-toast span{display:block;color:rgba(255,255,255,.78);font-size:12.5px;margin-top:2px}' +
    /* 12. Kopfzeile */
    '.mhks-top{display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:10px 12px;background:#fff;border:1px solid #ECE7DE;border-radius:14px;padding:10px 12px;margin:0 0 12px;font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif;box-shadow:0 1px 2px rgba(27,27,25,.04)}' +
    '.mhks-top__img{width:40px;height:40px;border-radius:9px;background:#F3F0EA center/cover no-repeat;border:1px solid #ECE7DE}' +
    '.mhks-top__t{min-width:0}.mhks-top__t b{display:block;font-size:13.5px;font-weight:700;color:#1B1B19;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.mhks-top__t small{display:block;font-size:11.5px;color:#8A8A82;line-height:1.35;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.mhks-top__p{text-align:right;line-height:1.15}.mhks-top__p small{display:block;font-size:10.5px;color:#8A8A82}.mhks-top__p s{display:block;font-size:11px;color:#8A8A82}.mhks-top__p b{display:block;font-size:19px;font-weight:700;color:#8A0C16;white-space:nowrap}' +
    '.mhks-top__tools{grid-column:1/-1;display:flex;flex-wrap:wrap;gap:6px;margin:0!important}' +
    '.mhks-top__tools button{margin:0!important;padding:6px 12px!important;font-size:12px!important;min-height:0!important;height:auto!important;line-height:1.2!important;width:auto!important}' +
    '@media(max-width:600px){.mhks-top{padding:8px 10px;gap:8px 10px}.mhks-top__img{width:34px;height:34px}.mhks-top__p b{font-size:16px}}' +
    /* 13. Dein Set steht */
    '.mhks-set{border:1.5px solid #1B1B19;border-radius:16px;background:#fff;margin:0 0 14px;overflow:hidden;font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif;color:#1B1B19;text-align:left}' +
    '.mhks-set__in{padding:16px 16px 12px}' +
    '.mhks-set__h{display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap}' +
    '.mhks-set__h>b{font-size:17px;font-weight:700}' +
    '.mhks-set__pr{display:flex;align-items:baseline;gap:8px;white-space:nowrap}.mhks-set__pr s{font-size:14px;color:#8A8A82}.mhks-set__pr b{font-size:24px;font-weight:700;letter-spacing:-.01em}' +
    '.mhks-set__sv{margin:4px 0 0;font-size:13px;font-weight:700;color:#E30B13}.mhks-set__sv span{font-weight:400;color:#6B6B65}' +
    '.mhks-set__ak{margin:10px 0 0;padding:8px 11px;border-radius:10px;background:#FBECEC;border:1px dashed #B0101C;font-size:12.5px;line-height:1.45;color:#5A0A10}.mhks-set__ak b{color:#8A0C16}' +
    '.mhks-set__l{list-style:none;margin:12px 0 0!important;padding:12px 0 0!important;border-top:1px solid #ECE7DE}' +
    '.mhks-set__l li{display:flex;gap:8px;align-items:baseline;margin:0 0 7px!important;padding:0!important;font-size:13.5px;line-height:1.4;list-style:none}.mhks-set__l li::before{content:"✓";color:#2E7D32;font-weight:700;flex:none}' +
    '.mhks-set__l li b{font-weight:700;white-space:nowrap}.mhks-set__l li span{color:#6B6B65;min-width:0}' +
    '.mhks-set .mhks-set__t{display:flex;justify-content:space-between;align-items:center;width:100%;margin:0;padding:12px 16px;border:0;border-top:1px solid #ECE7DE;border-radius:0;background:#F6F4EF;color:#1B1B19;font:inherit;font-size:14px;font-weight:700;cursor:pointer;text-transform:none;letter-spacing:normal;min-height:0;height:auto}' +
    '.mhks-set .mhks-set__t i{font-style:normal;font-size:18px;line-height:1;color:#6B6B65}' +
    '.mhks-has-set:not(.mhks-bom-open) [data-r="bom"],.mhks-has-set:not(.mhks-bom-open) #bom,.mhks-has-set:not(.mhks-bom-open) [data-mhzk-setwrap]{display:none!important}' +
    '.mhks-has-set .mh-konf-sumhide,.mhks-has-set .mhzk__price{display:none!important}' +
    '.mh-konf .bom-q small s.mh-cap{color:#8A8A82;font-weight:400;margin-right:3px}' +
    /* 14. Live ansehen: Knoepfe im Ergebnis-/Foto-Dialog (Dialog liegt ausserhalb von .mh-konf) */
    '.mh-live-foot .btn,.mh-live-foot a.btn{display:inline-flex!important;align-items:center;justify-content:center;gap:7px;min-height:44px;padding:11px 20px!important;border-radius:999px!important;border:2px solid #1B1B19!important;background:#fff!important;color:#1B1B19!important;font-size:14.5px!important;font-weight:700!important;line-height:1.2!important;text-decoration:none!important;cursor:pointer;text-transform:none;letter-spacing:normal;width:auto;margin:0}' +
    '.mh-live-foot .btn-primary,.mh-live-foot #liveGo{background:#B0101C!important;border-color:#B0101C!important;color:#fff!important;box-shadow:0 6px 16px rgba(176,16,28,.28)}' +
    '.mh-live-foot .btn-primary:hover,.mh-live-foot #liveGo:hover{background:#8A0C16!important;border-color:#8A0C16!important}' +
    '.mh-live-foot .mhks-wa,.mhdx-foot .mhks-wa,.mhzk-ov .mhks-wa{display:inline-flex!important;align-items:center;gap:7px;min-height:44px;padding:11px 18px!important;border-radius:999px!important;border:2px solid #25D366!important;background:#25D366!important;color:#fff!important;font-size:14.5px!important;font-weight:700!important;line-height:1.2;cursor:pointer;margin:0;width:auto;text-transform:none;letter-spacing:normal}' +
    '.mhks-wa svg{width:18px;height:18px;flex:none}' +
    /* Foto-Auswahl Doppelstab/Sichtschutz: Standard-Dateifeld ("Keine ausgewählt") durch einen Knopf ersetzen */
    '.mhdx-drop input[type="file"],.mhzk-live__drop input[type="file"]{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;overflow:hidden!important;margin:0!important;padding:0!important;pointer-events:none}' +
    '.mhdx-drop,.mhzk-live__drop{position:relative}' +
    '.mh-live-drop input[type="file"]{pointer-events:none!important}.mh-live-drop.on{cursor:pointer}' +
    '.mhdx-drop::after,.mhzk-live__drop::after{content:"Foto auswählen";display:table;margin:14px auto 0;padding:11px 20px;border-radius:999px;background:#B0101C;color:#fff;font-weight:700;font-size:14px}' +
    /* 15. Badge auf Produktseiten */
    '.mhks-pb{display:inline-flex;align-items:center;gap:8px;margin:10px 0 4px;padding:9px 15px 9px 10px;border-radius:999px;background:linear-gradient(135deg,#B0101C,#8A0C16);color:#fff!important;font-size:14px;font-weight:700;line-height:1.2;text-decoration:none!important;box-shadow:0 6px 16px rgba(176,16,28,.28);cursor:pointer;border:0;font-family:inherit;width:auto;max-width:100%}' +
    '.mhks-pb:hover{filter:brightness(1.06)}' +
    '.mhks-pb i{display:inline-flex;width:24px;height:24px;border-radius:50%;background:#fff;color:#8A0C16;align-items:center;justify-content:center;font-style:normal;flex:none}' +
    '.mhks-pb i svg{width:15px;height:15px}.mhks-pb small{font-weight:500;opacity:.9;font-size:12px}' +
    /* 11. Mini-Vorschau */
    '.mhks-mini{position:fixed;left:50%;top:var(--mhks-mini-top,12px);z-index:100002;width:260px;max-width:60vw;margin-left:-130px;background:#fff;border:1.5px solid #E3DED4;border-radius:14px;box-shadow:0 10px 30px rgba(27,27,25,.22);overflow:hidden;cursor:pointer;opacity:0;transform:translateY(-12px);pointer-events:none;transition:opacity .2s,transform .2s;font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif}' +
    '.mhks-mini.on{opacity:1;transform:none;pointer-events:auto}' +
    '.mhks-mini__img{display:flex;align-items:center;justify-content:center;height:140px;padding:6px;background:#F6F4EF}' +
    '.mhks-mini__img>svg,.mhks-mini__img>canvas,.mhks-mini__img>img{display:block;max-width:100%!important;max-height:100%!important;width:auto!important;height:auto!important}' +
    '.mhks-mini__img>svg{width:100%!important;height:100%!important}' +
    '.mhks-mini__bar{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:6px 10px;font-size:11.5px;font-weight:700;color:#1B1B19;border-top:1px solid #EFECE4}' +
    '.mhks-mini__bar span{color:#8A0C16}' +
    '.mhks-mini__x{position:absolute;top:6px;right:6px;width:24px;height:24px;min-height:0;padding:0;margin:0;border:0;border-radius:50%;background:rgba(27,27,25,.75);color:#fff;font-size:12px;line-height:24px;text-align:center;cursor:pointer}' +
    /* 02.10.2026: am Handy flache Leiste direkt unter dem Kopf - Plan links, Text rechts. So bleiben die Masse darunter sichtbar und bedienbar */
    '@media(max-width:989px){.mhks-mini{left:10px;right:10px;width:auto;max-width:none;margin-left:0;display:flex;align-items:stretch;border-radius:12px}' +
    '.mhks-mini__img{flex:0 0 112px;height:64px;padding:4px;border-right:1px solid #EFECE4}' +
    '.mhks-mini__bar{flex:1;flex-direction:column;align-items:flex-start;justify-content:center;gap:2px;border-top:0;padding:6px 40px 6px 12px;font-size:13px}' +
    '.mhks-mini__bar span{font-size:12px}.mhks-mini__x{top:50%;margin-top:-12px;right:8px}}' +
    /* 17. Preisleiste am Handy */
    '.mhks-pbar{position:fixed;left:0;right:0;bottom:0;z-index:100001;display:flex;align-items:center;justify-content:space-between;gap:12px;box-sizing:border-box;padding:9px 16px calc(9px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #E3DED4;box-shadow:0 -6px 20px rgba(27,27,25,.08);transform:translateY(115%);visibility:hidden;transition:transform .2s,visibility .2s;font-family:var(--body-font-family,var(--font-body-family,Inter)),sans-serif}' +
    '.mhks-pbar.on{transform:none;visibility:visible}' +
    '.mhks-pbar__p{min-width:0;line-height:1.2}.mhks-pbar__p small{display:block;font-size:11px;color:#6B6B65}' +
    '.mhks-pbar__p span{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap}.mhks-pbar__p s{font-size:12px;color:#8A8A82}' +
    '.mhks-pbar__p b{font-size:19px;font-weight:800;color:#1B1B19;font-variant-numeric:tabular-nums}' +
    '.mhks-pbar__p em{display:block;font-style:normal;font-size:11.5px;font-weight:700;color:#1F7A3A}' +
    '.mhks-pbar .mhks-pbar__go{flex:none;width:auto!important;min-height:46px!important;margin:0!important;padding:12px 22px!important;border:0!important;border-radius:999px!important;background:#B0101C!important;color:#fff!important;font-family:inherit!important;font-size:15px!important;font-weight:700!important;line-height:1.2!important;letter-spacing:normal!important;text-transform:none!important;box-shadow:none!important;cursor:pointer}' +
    '.mhks-pbar .mhks-pbar__go:hover{background:#8A0C16!important}.mhks-pbar .mhks-pbar__go:disabled{opacity:.5;cursor:not-allowed}' +
    'html.mhks-pbar-on body{padding-bottom:calc(66px + env(safe-area-inset-bottom))}html.mhks-pbar-on .mhtk-modal__dialog{padding-bottom:76px}' +
    '@media(max-width:989px){.mh-konf .mcta{display:none!important}.mh-konf.is-step4{padding-bottom:0!important}}' +
    '@media(min-width:990px){.mhks-pbar{display:none!important}}' +
    /* 30.09.2026: Zurueck-Buttons in allen Konfiguratoren gleich und deutlich */
    '.mhds-app .mhds-back,.mh-konf .nav > button.btn-ghost,.mhzk-app .mhzk-nav__back{display:inline-flex!important;align-items:center;justify-content:center;gap:6px;min-height:46px;padding:11px 20px!important;border:2px solid #1B1B19!important;border-radius:999px!important;background:#fff!important;color:#1B1B19!important;font-size:14.5px!important;font-weight:700!important;line-height:1.2;cursor:pointer;box-shadow:none}' +
    '.mhds-app .mhds-back:hover,.mh-konf .nav > button.btn-ghost:hover,.mhzk-app .mhzk-nav__back:hover{background:#1B1B19!important;color:#fff!important}' +
    '.mhds-app .mhds-back::before{content:"‹";font-size:20px;line-height:1;margin-top:-2px}' +
    /* 30.09.2026: Weiter- und Warenkorb-Knoepfe in allen vier gleich (orange, rund, gleiche Hoehe) */
    '.mhds-app .mhds-next,.mh-konf .nav > button.btn-primary,.mhzk-app .mhzk-nav__next{display:inline-flex!important;align-items:center;justify-content:center;gap:6px;min-height:46px;padding:11px 22px!important;border:2px solid #B0101C!important;border-radius:999px!important;background:#B0101C!important;color:#fff!important;font-size:14.5px!important;font-weight:700!important;line-height:1.2;cursor:pointer}' +
    '.mhds-app .mhds-next:hover,.mh-konf .nav > button.btn-primary:hover,.mhzk-app .mhzk-nav__next:hover{background:#8A0C16!important;border-color:#8A0C16!important}' +
    '.mhds-app .mhds-cta,.mh-konf .btn-cart{display:flex!important}' +
    '.mhds-app .mhds-cta,.mh-konf .btn-cart,.mhzk-app .mhzk__cta{align-items:center;justify-content:center;gap:9px;width:100%;min-height:56px;padding:14px 20px!important;border:0!important;border-radius:999px!important;background:#B0101C!important;color:#fff!important;font-size:16px!important;font-weight:700!important;line-height:1.2;letter-spacing:normal;text-transform:none;cursor:pointer;box-shadow:0 8px 20px rgba(176,16,28,.28)}' +
    '.mhds-app .mhds-cta:hover,.mh-konf .btn-cart:hover,.mhzk-app .mhzk__cta:hover{background:#8A0C16!important}' +
    '.mhds-app .mhds-cta:disabled,.mh-konf .btn-cart:disabled,.mhzk-app .mhzk__cta:disabled{opacity:.5;cursor:not-allowed;box-shadow:none}' +
    '.mhks-ov .mhks-sec{display:block;width:100%;height:auto;min-height:0;margin:10px 0 0;padding:11px 18px;border:1.5px solid #D7D3CA;border-radius:11px;background:#fff;color:#5E5E59;font-size:14px;font-weight:700;font-family:inherit;cursor:pointer;text-transform:none;letter-spacing:normal}' +
    '.mhks-ov .mhks-sec:hover{border-color:#8A8A82;color:#1B1B19}' +
    '.mhks-ov .mhks-x{position:absolute;top:14px;right:14px;width:34px;height:34px;min-width:34px;max-width:34px;min-height:0;margin:0;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;background:#1B1B19;border-radius:50%;cursor:pointer;font-size:14px;color:#fff;line-height:1}' +
    '.mhks-note{font-size:11px;color:#8A8A82;margin:10px 0 0;line-height:1.45}' +
    '.mhks-link{display:flex;gap:8px;margin:0 0 12px}' +
    '.mhks-ov .mhks-link input{flex:1;min-width:0;height:auto;margin:0;padding:10px 12px;font-size:12.5px;font-family:inherit;color:#5E5E59;background:#fff;border:1.5px solid #D7D3CA;border-radius:10px}' +
    '.mhks-share{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '.mhks-ov .mhks-sh{display:flex;align-items:center;justify-content:center;gap:8px;height:auto;min-height:0;margin:0;padding:11px 10px;border:1.5px solid #D7D3CA;border-radius:11px;background:#fff;color:#1B1B19;font-size:13.5px;font-weight:700;font-family:inherit;cursor:pointer;text-decoration:none;text-transform:none;letter-spacing:normal;line-height:1.2}' +
    '.mhks-ov .mhks-sh:hover{border-color:#B0101C;color:#8A0C16}' +
    '.mhks-sh svg{width:18px;height:18px;flex:none}' +
    '.mhks-sh--wa svg{color:#25D366}' +
    '.mhks-ok{display:flex;gap:10px;align-items:flex-start;background:#EAF4EA;color:#1E5A2A;border-radius:11px;padding:10px 12px;font-size:12.5px;line-height:1.45;margin:0 0 14px}' +
    '.mhks-help-ic{width:46px;height:46px;border-radius:50%;background:#FBECEC;color:#8A0C16;display:flex;align-items:center;justify-content:center;margin:0 0 12px}' +
    '.mhks-help-ic svg{width:24px;height:24px}' +
    /* 7. Feedback */
    '.mhks-ov--inline{position:static;inset:auto;z-index:auto;background:none;padding:0;display:block}' +
    '.mhks-ov--inline .mhks-box{max-width:680px;margin:0 auto;max-height:none;overflow:visible;box-shadow:0 6px 30px rgba(0,0,0,.08)}' +
    '.mhks-fb-q{border:0;margin:0 0 16px;padding:0;min-width:0}' +
    '.mhks-fb-q legend,.mhks-fb-q>.mhks-l{display:block;font-size:13.5px;font-weight:700;color:#1B1B19;margin:0 0 8px;padding:0;line-height:1.35}' +
    '.mhks-fb-q legend small{font-weight:400;color:#8A8A82;font-size:12px}' +
    '.mhks-chips{display:flex;flex-wrap:wrap;gap:7px}' +
    '.mhks-ov .mhks-chip{display:inline-flex;align-items:center;height:auto;min-height:0;width:auto;margin:0;padding:8px 13px;border:1.5px solid #D7D3CA;border-radius:999px;background:#fff;color:#1B1B19;font-size:13px;font-weight:600;font-family:inherit;line-height:1.2;cursor:pointer;text-transform:none;letter-spacing:normal}' +
    '.mhks-ov .mhks-chip:hover{border-color:#B0101C}' +
    '.mhks-ov .mhks-chip[aria-pressed="true"]{border-color:#B0101C;background:#FBECEC;color:#8A0C16}' +
    '.mhks-stars{display:flex;gap:4px;align-items:center}' +
    '.mhks-ov .mhks-star{width:40px;height:40px;min-width:0;min-height:0;margin:0;padding:0;border:0;background:none;color:#D7D3CA;font-size:32px;line-height:1;cursor:pointer;font-family:inherit}' +
    '.mhks-ov .mhks-star.on{color:#B0101C}' +
    '.mhks-stars__lbl{font-size:12px;color:#8A8A82;margin-left:8px}' +
    '.mhks-ov textarea.mhks-in{min-height:88px;resize:vertical;line-height:1.45;font-size:14px}' +
    '.mhks-hp{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;overflow:hidden!important}' +
    '.mhks-fb-ic{width:46px;height:46px;border-radius:50%;background:#FBECEC;color:#8A0C16;display:flex;align-items:center;justify-content:center;margin:0 0 12px}' +
    '.mhks-fb-ic svg{width:24px;height:24px}' +
    '.mhks-row.mhks-row--2{grid-template-columns:1fr 1fr}' +
    '@media(max-width:480px){.mhks-row,.mhks-row.mhks-row--2{grid-template-columns:1fr}.mhks-share{grid-template-columns:1fr}}';

  function ensureCss() {
    if (document.getElementById('mhksCss')) return;
    var st = document.createElement('style');
    st.id = 'mhksCss'; st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  ensureCss();

  /* i-Symbole: Klick/Tipp auf Touch-Geraeten oeffnet den Hinweis, Klick daneben schliesst */
  document.addEventListener('click', function (e) {
    var i = e.target && e.target.closest ? e.target.closest('.mhk-i') : null;
    var open = document.querySelectorAll('.mhk-i.is-open');
    for (var k = 0; k < open.length; k++) if (open[k] !== i) open[k].classList.remove('is-open');
    if (i && !(e.target.closest && e.target.closest('.mhk-i__tip'))) { e.preventDefault(); e.stopPropagation(); i.classList.toggle('is-open'); }
  }, true);
  /* Hinweis im Bild halten: auf schmalen Bildschirmen sitzt das i oft am Rand, der mittig
     ausgerichtete Hinweis wuerde links oder rechts abgeschnitten - beim Oeffnen seitlich schieben. */
  function fitTip(i) {
    var t = i.querySelector('.mhk-i__tip'); if (!t) return;
    t.style.marginLeft = '0px';
    requestAnimationFrame(function () {
      var r = t.getBoundingClientRect(), vw = document.documentElement.clientWidth, d = 0;
      if (!r.width) return;
      if (r.left < 8) d = 8 - r.left; else if (r.right > vw - 8) d = vw - 8 - r.right;
      t.style.marginLeft = Math.round(d) + 'px';
    });
  }
  ['mouseover', 'focusin', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var i = e.target && e.target.closest ? e.target.closest('.mhk-i') : null;
      if (i && !e.target.closest('.mhk-i__tip')) fitTip(i);
    }, true);
  });

  function infoMarkup(title, text, down) {
    return '<span class="mhk-i' + (down ? ' mhk-i--down' : '') + '" tabindex="0" role="button" aria-label="Mehr Infos">i'
      + '<span class="mhk-i__tip" role="tooltip">' + (title ? '<b>' + esc(title) + '</b>' : '') + esc(text) + '</span></span>';
  }
  /* Kuerzt einen Hilfetext auf "kurz" und legt den vollen Text hinter ein i-Symbol.
     Idempotent - der Konfigurator darf das Element neu rendern, dann wird erneut gekuerzt. */
  function info(el, kurz, title, down) {
    if (!el) return;
    var full = (el.getAttribute('data-mhk-full') || el.textContent || '').trim();
    if (!full) return;
    if (el.getAttribute('data-mhk-done') === full + '|' + kurz) return;
    el.setAttribute('data-mhk-full', full);
    el.innerHTML = esc(kurz) + infoMarkup(title, full, down);
    el.setAttribute('data-mhk-done', full + '|' + kurz);
  }

  /* ---------- 1. Beratungs-Hinweis nach 60 s ohne Eingabe ---------- */
  var idleT = null, helpDone = false;
  function armIdle() {
    if (helpDone) return;
    clearTimeout(idleT);
    idleT = setTimeout(fireIdle, IDLE_MS);
  }
  function fireIdle() {
    if (helpDone) return;
    if (ss('mhKonfHelp')) { helpDone = true; return; }
    var a = active();
    if (!a || document.hidden || document.querySelector('.mhks-ov')) { armIdle(); return; }
    helpDone = true;
    ss('mhKonfHelp', '1');
    showHelp(a);
  }
  ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'input'].forEach(function (ev) {
    document.addEventListener(ev, armIdle, { passive: true, capture: true });
  });
  document.addEventListener('scroll', armIdle, { passive: true, capture: true });
  armIdle();

  function overlay(html, cls) {
    ensureCss();
    var ov = document.createElement('div');
    ov.className = 'mhks-ov' + (cls ? ' ' + cls : '');
    ov.innerHTML = html;
    document.body.appendChild(ov);
    function close() { ov.remove(); document.removeEventListener('keydown', onKey, true); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey, true);
    ov.addEventListener('click', function (e) { if (e.target === ov || (e.target.closest && e.target.closest('[data-mhks-close]'))) close(); });
    ov.__close = close;
    return ov;
  }

  function showHelp(a) {
    overlay(
      '<div class="mhks-box" role="dialog" aria-modal="true" aria-label="Kostenlose Beratung">' +
        '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>' +
        '<div class="mhks-help-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1v-6h3v4zM3 19a2 2 0 0 0 2 2h1v-6H3v4z"/></svg></div>' +
        '<b class="mhks-t">Sollen wir ' + esc(a.c.was) + ' gemeinsam planen?</b>' +
        '<p class="mhks-p">Unsere Fachberater gehen Ihre Planung mit Ihnen durch – kostenlos und unverbindlich. Suchen Sie sich einfach einen Termin aus.</p>' +
        '<a class="mhks-go" href="' + TERMIN_URL + '" target="_blank" rel="noopener" data-mhks-close data-mhks-beratung="' + a.key + '">Kostenlosen Beratungstermin buchen</a>' +
        '<button type="button" class="mhks-sec" data-mhks-close>Ich plane selbst weiter</button>' +
      '</div>', 'mhks-help');
  }

  /* ---------- 2. Kennung fuer Warenkorb und Bestellung ---------- */
  var lastKonf = null, lastKonfT = 0;
  function markKonf(e) { var k = keyOf(e.target); if (k) { lastKonf = k; lastKonfT = Date.now(); } }
  document.addEventListener('pointerdown', markKonf, true);
  document.addEventListener('keydown', markKonf, true);
  document.addEventListener('click', markKonf, true);

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var konf = null, konfKey = null, isAdd = false;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
        if (isAdd && init && typeof init.body === 'string'
            && lastKonf && Date.now() - lastKonfT < 30000) {
          var body = JSON.parse(init.body);
          konf = KONF[lastKonf].name; konfKey = lastKonf;
          /* 22.10.2026 (EP, Abnahme F9): Detail-Attribute der App nicht direkt schreiben lassen,
             sondern nach dem Hinzufuegen konfiguratorweise zusammenfuehren (syncAttrs). */
          var det = null;
          if (body.attributes && typeof body.attributes === 'object') {
            det = {};
            Object.keys(body.attributes).forEach(function (k) { if (k !== 'Konfigurator' && body.attributes[k] != null && body.attributes[k] !== '') det[k] = String(body.attributes[k]); });
            delete body.attributes;
          }
          /* 30.09.2026: gemeinsame Kennung + Link zum Bearbeiten fuer alle Positionen dieser Planung */
          var mid = 'K' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase(), mlink = '';
          try {
            var ad0 = adapters[konfKey], d0 = ad0 && ad0.serialize ? ad0.serialize() : null;
            if (d0) { mlink = buildLink(konfKey, withMeta(d0, loadedMeta && loadedMeta.key === konfKey ? loadedMeta.n : '', loadedMeta && loadedMeta.key === konfKey ? loadedMeta.d : '')); mlink += (mlink.indexOf('?') < 0 ? '?' : '&') + 'mhre=' + mid; }
          } catch (x0) { mlink = ''; }
          var tag = function (it) {
            it.properties = it.properties || {}; it.properties._konfigurator = konf;
            it.properties._mh_id = mid;
            if (mlink && mlink.length < 3800) it.properties._mh_link = mlink;
          };
          if (body.items && body.items.length) body.items.forEach(tag);
          else if (body.id) tag(body);
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      } catch (e) { konf = null; }
      var p = nativeFetch.call(this, input, init);
      if (konf) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          var prevSame = lastAdded[konfKey];
          lastAdded[konfKey] = mid;
          closeKonfModal(konfKey);
          try { snapCart(konfKey); } catch (x1) {}   /* 18. in_cart-Flag am Autosave-Eintrag */
          /* Warenkorb-Attribute: landen an der Bestellung (Zusatzinformationen) - erst nach dem Ersetzen */
          Promise.resolve(replaceOld(konfKey, mid, prevSame)).catch(function () {}).then(function () { return syncAttrs(konf, det); }).catch(function () {});
        }).catch(function () {});
      }
      /* Abnahme F9: nach Mengenaenderung/Entfernen im Warenkorb die Konfigurator-Attribute nachziehen */
      try {
        var url2 = typeof input === 'string' ? input : (input && input.url) || '';
        if (!konf && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url2)) {
          p.then(function (r) { if (r && r.ok) setTimeout(function () { syncAttrs(null, null); }, 50); }).catch(function () {});
        }
      } catch (e2) {}
      /* 18. Pergola legt ohne Suite-Kennung in den Warenkorb (kein KONF-Eintrag): in_cart ueber das Pergola-Event */
      if (!konf && isAdd && document.getElementById('mhpg-data')) p.then(function (r) { if (r && r.ok) { try { snapCart('pergola'); } catch (x2) {} } }).catch(function () {});
      return p;
    };
  }

  /* ---------- 10. Planung bearbeiten aus dem Warenkorb ---------- */
  /* 22.10.2026 (EP): Enterprise-Drawer hoert auf dispatch:cart-drawer:refresh/:open; auf /cart neu laden */
  function refreshCart() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    try {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: null } })); }, 60);
    } catch (e) {}
  }
  /* 01.10.2026: Nach "In den Warenkorb" schliesst sich das Konfigurator-PopUp der Produktseite,
     damit der Warenkorb (Drawer) sichtbar ist. */
  function closeKonfModal(key) {
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.mhtk-modal.is-open'), function (m) {
        if (!m.querySelector(KONF[key].root)) return;
        var x = m.querySelector('[data-mhtk-close]');
        if (x) x.click(); else { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
      });
    }, 250);
  }
  /* Kam der Kunde ueber "Planung bearbeiten", werden die alten Positionen dieser Planung ersetzt */
  /* 22.10.2026 (EP, Abnahme F9): Warenkorb-Attribute je Konfigurator, ohne Vermischung.
     - "Konfigurator" = kommagetrennte Liste der Konfiguratoren, deren Positionen (Property _konfigurator)
       im Warenkorb liegen (eine Planung: genau wie bisher, z. B. "WPC-Dielen").
     - Liegt nur EIN Konfigurator im Warenkorb, stehen seine Detail-Attribute wie bisher ohne Zusatz
       (Form, Fläche, Diele, Platte, Verlegeart, Aufbauhöhe …) – Odoo/Bestellnotiz unveraendert.
     - Liegen MEHRERE im Warenkorb, bekommt jedes Detail-Attribut den Konfigurator in Klammern,
       z. B. "Fläche (WPC-Dielen)" und "Fläche (Terrassenplatten)"; die Felder ohne Zusatz werden geleert.
     - Detail-Attribute eines Konfigurators, von dem keine Position mehr im Warenkorb liegt, werden geleert.
     Der Warenkorb beschreibt sich damit selbst (keine Zusatzspeicherung noetig). */
  var DETAIL_KEYS = ['Form', 'Fläche', 'Diele', 'Unterkonstruktion', 'Aufbauhöhe', 'Platte', 'Verlegeart', 'Verlegung'];
  function detailKeys() {
    var k = DETAIL_KEYS.slice();
    try { (JSON.parse(ls('epKonfAttrKeys') || '[]') || []).forEach(function (x) { if (typeof x === 'string' && k.indexOf(x) < 0) k.push(x); }); } catch (e) {}
    return k;
  }
  function learnKeys(det) {
    if (!det) return;
    var k = detailKeys(), add = false;
    Object.keys(det).forEach(function (x) { if (k.indexOf(x) < 0 && x.length < 40) { k.push(x); add = true; } });
    if (add) ls('epKonfAttrKeys', JSON.stringify(k.slice(DETAIL_KEYS.length).slice(-30)));
  }
  var syncBusy = Promise.resolve();
  function syncAttrs(konf, det) {
    learnKeys(det);
    syncBusy = syncBusy.then(function () { return doSyncAttrs(konf, det); }, function () { return doSyncAttrs(konf, det); });
    return syncBusy;
  }
  function doSyncAttrs(konf, det) {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var attrs = cart.attributes || {}, keys = detailKeys(), names = [], present = [];
      KEYS.forEach(function (k) { names.push(KONF[k].name); });
      (cart.items || []).forEach(function (it) {
        var n = it.properties && it.properties._konfigurator;
        if (n && present.indexOf(n) < 0) present.push(n);
        if (n && names.indexOf(n) < 0) names.push(n);
      });
      if (konf && present.indexOf(konf) < 0) present.push(konf);
      var prev = String(attrs.Konfigurator || '').split(/\s*,\s*/).filter(Boolean);
      if (!konf && !prev.length && !Object.keys(attrs).some(function (a) { return / \(.+\)$/.test(a); })) return;
      var rx = /^(.+) \((.+)\)$/, details = {}, upd = {};
      Object.keys(attrs).forEach(function (a) {
        var m = rx.exec(a);
        if (m && names.indexOf(m[2]) >= 0 && keys.indexOf(m[1]) >= 0) {
          (details[m[2]] = details[m[2]] || {})[m[1]] = attrs[a]; upd[a] = '';
        } else if (keys.indexOf(a) >= 0) {
          if (prev.length === 1) (details[prev[0]] = details[prev[0]] || {})[a] = attrs[a];
          upd[a] = '';
        }
      });
      if (konf) details[konf] = det || {};
      var multi = present.length > 1;
      present.forEach(function (n) {
        var d = details[n] || {};
        Object.keys(d).forEach(function (k) { if (d[k] !== '' && d[k] != null) upd[multi ? k + ' (' + n + ')' : k] = String(d[k]); });
      });
      upd.Konfigurator = present.join(', ');
      var same = Object.keys(upd).every(function (a) { return String(attrs[a] == null ? '' : attrs[a]) === upd[a]; });
      if (same) return;
      return nativeFetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: upd })
      });
    }).catch(function () {});
  }

  /* 22.10.2026 (EP, Abnahme F3): Ersetzt wird
       a) die Planung, die ueber "Planung bearbeiten" (mhre) geladen wurde, und
       b) die Planung, die in diesem Seitenaufruf schon aus demselben Konfigurator in den Warenkorb kam
          (erneutes "In den Warenkorb" aus demselben PopUp = nachgebesserte Planung).
     Gilt fuer alle Konfiguratoren gleich, weil es im gemeinsamen fetch-Wrapper sitzt. */
  var lastAdded = {};
  function replaceOld(key, newId, prevSame) {
    var rp = null, ids = [];
    try { rp = JSON.parse(ss('mhKonfReplace') || 'null'); } catch (e) { rp = null; }
    if (rp && rp.key === key && rp.id && rp.id !== newId) { ids.push(rp.id); try { window.sessionStorage.removeItem('mhKonfReplace'); } catch (e) {} }
    if (prevSame && prevSame !== newId && ids.indexOf(prevSame) < 0) ids.push(prevSame);
    if (!ids.length) return null;
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var upd = {}, n = 0;
      (cart.items || []).forEach(function (it) { if (it.properties && ids.indexOf(it.properties._mh_id) >= 0) { upd[it.key] = 0; n++; } });
      if (!n) return;
      return nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function () { setTimeout(refreshCart, 150); toast('Warenkorb aktualisiert', 'Die bisherigen Positionen dieser Planung wurden durch die neue Planung ersetzt.'); });
    }).catch(function () {});
  }
  var EDIT_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var editSig = '', editBusy = false;
  /* 01.10.2026: "Planung bearbeiten" steht nicht an der Position, sondern im Warenkorb-Abschluss.
     22.10.2026 (EP/Enterprise): oben in .cart-drawer__summary (Drawer) bzw. #cart-summary (/cart). */
  function linkName(link) {   /* Name aus dem _m-Teil des Planungs-Links */
    try {
      var q = new URL(link, window.location.origin).searchParams.get('konf') || '', dot = q.indexOf('.');
      var d = dot > 0 ? b64d(q.slice(dot + 1)) : null;
      return d && d._m && d._m.n ? String(d._m.n).slice(0, 60) : '';
    } catch (e) { return ''; }
  }
  function idZeit(id) {   /* _mh_id = "K" + Zeitstempel (Basis 36) + 3 Zufallszeichen */
    var m = /^K([0-9A-Z]+)[0-9A-Z]{3}$/.exec(id || ''); if (!m) return '';
    var t = parseInt(m[1], 36); if (!(t > 1.6e12 && t < 4e12)) return '';
    var d = new Date(t);
    return d.toLocaleDateString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + d.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) + ' Uhr';
  }
  var CART_ITEM_SEL = 'tr.cart-item[id^="cart-item-"]';
  function cartRows() { return document.querySelectorAll(CART_ITEM_SEL); }
  function inDrawer(el) { return !!(el && el.closest && el.closest('cart-drawer,#cart-drawer')); }
  function editHosts() {
    var out = [], rows = cartRows(), hasDrawer = false, hasPage = false;
    for (var i = 0; i < rows.length; i++) { if (inDrawer(rows[i])) hasDrawer = true; else hasPage = true; }
    if (hasDrawer) {
      var ds = document.querySelector('cart-drawer .cart-drawer__summary, #cart-drawer .cart-drawer__summary');
      if (ds) out.push([ds, ds.firstChild]);
    }
    if (hasPage) {
      var cs = document.getElementById('cart-summary');
      if (cs && !inDrawer(cs)) out.push([cs, cs.firstChild]);
    }
    return out;
  }
  function rowQty(li) {   /* Enterprise hat kein data-quantity - Wert aus dem Mengenfeld */
    var q = li.querySelector('input[name="updates[]"],input[type="number"],input[data-index]');
    return q ? q.value : '';
  }
  function editSigNow() {
    return [].map.call(cartRows(), function (li) { return (inDrawer(li) ? 'd' : 'p') + li.id + ':' + (li.getAttribute('data-variant-id') || '') + ':' + rowQty(li); }).join('|')
      + '#' + editHosts().map(function (h) { return h[0].querySelector(':scope > .mhks-editbox') ? 1 : 0; }).join('');
  }
  function injectEditLinks() {
    var lis = cartRows();
    if (!lis.length || editBusy) return;
    var sig = editSigNow();
    if (sig === editSig) return;
    editBusy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var seen = {}, groups = [];
      (cart.items || []).forEach(function (it) {
        var pr = it.properties || {};
        if (!pr._mh_link || seen[pr._mh_id || pr._mh_link]) return;
        seen[pr._mh_id || pr._mh_link] = 1;
        groups.push({ link: pr._mh_link, name: pr._konfigurator || '', id: pr._mh_id || '' });
      });
      [].forEach.call(document.querySelectorAll('.mhks-edit'), function (x) { if (!x.closest('.mhks-editbox')) x.remove(); });
      editHosts().forEach(function (h) {
        var box = h[0].querySelector(':scope > .mhks-editbox');
        if (!groups.length) { if (box) box.remove(); return; }
        /* 01.10.2026: Beschriftung = gespeicherter Name der Planung, sonst Datum + Uhrzeit des Hinzufuegens */
        var html = groups.map(function (g) {
          var nm = linkName(g.link), zeit = idZeit(g.id), sl = safeLink(g.link);   /* 13.10.2026: Schema-/Origin-Pruefung */
          var zus = nm ? ' · ' + nm : (groups.length > 1 ? ' · ' + (zeit || g.name || 'Planung') : '');
          if (!sl) return '<span class="mhks-edit">' + EDIT_IC + 'Planung' + esc(zus) + '</span>';
          return '<a class="mhks-edit" href="' + esc(sl) + '" title="Öffnet Ihre Planung im Konfigurator – beim erneuten Hinzufügen werden die Positionen ersetzt">' + EDIT_IC + 'Planung bearbeiten' + esc(zus) + '</a>';
        }).join('');
        if (!box) { box = document.createElement('div'); box.className = 'mhks-editbox'; h[0].insertBefore(box, h[1] || null); }
        if (box.__h !== html) { box.innerHTML = html; box.__h = html; }
      });
    }).catch(function () {}).then(function () {
      editBusy = false;
      editSig = editSigNow();
    });
  }
  var toastT = null;
  function toast(title, text) {
    ensureCss();
    var old = document.querySelector('.mhks-toast'); if (old) old.remove();
    var el = document.createElement('div'); el.className = 'mhks-toast'; el.setAttribute('role', 'status');
    el.innerHTML = '<b>' + esc(title) + '</b>' + (text ? '<span>' + esc(text) + '</span>' : '');
    document.body.appendChild(el);
    clearTimeout(toastT); toastT = setTimeout(function () { el.remove(); }, 6500);
  }

  /* ---------- Klaviyo ----------
     13.10.2026: Sicherheits-Review – Ereignisse (kEvent, klaviyo.push) nur mit Marketing-Einwilligung
     (marketingOk). Ausnahme kSubscribe: das gesetzte Newsletter-Haekchen ist die ausdrueckliche
     Einwilligung. Kurzlink, PDF und Feedback an den Worker laufen unabhaengig davon. */
  function kFetch(path, body) {
    if (typeof window.MH_KLAVIYO_TEST === 'function') { try { window.MH_KLAVIYO_TEST(path, body); } catch (e) {} return Promise.resolve(true); }
    if (!KLAVIYO_COMPANY) return Promise.resolve(false);   /* 22.10.2026 (EP): ohne company_id kein Klaviyo */
    return nativeFetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      keepalive: true,   /* Ereignis kommt auch an, wenn der Kunde gleich weiterklickt */
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + path + ' ' + r.status); return true; });
  }
  function kSubscribe(list, email, source) {
    if (!list || !KLAVIYO_COMPANY) return Promise.resolve(false);
    return kFetch('subscriptions', { data: { type: 'subscription', attributes: {
      custom_source: source,
      profile: { data: { type: 'profile', attributes: { email: email } } }
    }, relationships: { list: { data: { type: 'list', id: list } } } } });
  }
  function kEvent(email, plz, props, metric) {
    if (!email || !marketingOk()) return Promise.resolve(false);
    var prof = { email: email };
    if (plz) { prof.location = { zip: plz }; prof.properties = { PLZ: plz }; }
    return kFetch('events', { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: metric || 'Konfiguration gespeichert' } } },
      profile: { data: { type: 'profile', attributes: prof } }
    } } });
  }
  /* Newsletter-Einwilligung ist freiwillig: ohne Haekchen kein Eintrag in die Liste */
  var DS_LINK = '<a href="/policies/privacy-policy" target="_blank" rel="noopener" style="color:#B0101C">Datenschutzerklärung</a>';
  /* 22.10.2026 (EP): ohne Klaviyo-Liste kein Newsletter-Haekchen (sonst Einwilligung ins Leere) */
  function optinHtml(list) { return list && KLAVIYO_COMPANY ? '<label class="mhks-c"><input type="checkbox" name="ok"><span>' + OPTIN_TXT + '</span></label>' : '<input type="checkbox" name="ok" hidden>'; }
  var OPTIN_TXT = 'Ja, ich möchte zusätzlich Tipps, Angebote und Neuigkeiten von Englputzeder per E-Mail erhalten (freiwillig). Abmeldung jederzeit möglich. Mehr in der <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a>.';

  /* ---------- 3. Speichern & teilen ---------- */
  function b64e(obj) {
    var s = JSON.stringify(obj);
    var b = window.btoa(unescape(encodeURIComponent(s)));
    return b.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64d(str) {
    var b = str.replace(/-/g, '+').replace(/_/g, '/');
    while (b.length % 4) b += '=';
    return JSON.parse(decodeURIComponent(escape(window.atob(b))));
  }
  /* Name + Beschreibung reisen im Link mit (_m), der Konfigurator selbst sieht sie nie */
  var loadedMeta = null;
  function withMeta(data, n, d) {
    if (!n && !d) return data;
    var o = {}; Object.keys(data || {}).forEach(function (k) { o[k] = data[k]; });
    o._m = { n: n || '', d: d || '' };
    return o;
  }
  /* 02.10.2026: kurze Links - die Planung liegt beim Kurzlink-Worker, der Link traegt nur ?k=<Kennung>.
     Ist der Worker nicht erreichbar (oder EP_KONF_CFG.link leer), bleibt es beim langen Link mit ?konf=. */
  var LINK_API = String(CFG.link || window.MH_LINK_API || '').trim().replace(/\/+$/, '');
  function shortLink(long, meta) {   /* meta (05.10.2026): Angaben fuer die Uebersicht /liste im Worker */
    if (!LINK_API || !window.fetch) return Promise.resolve(long);
    var konf = '';
    try { konf = new URL(long).searchParams.get('konf') || ''; } catch (e) { konf = ''; }
    if (!konf) return Promise.resolve(long);
    var req = fetch(LINK_API + '/s', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(meta ? { konf: konf, meta: meta } : { konf: konf }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !/^[0-9A-Za-z]{8,12}$/.test(j.id)) return long;
        var u = new URL(long); u.searchParams.delete('konf'); u.searchParams.set('k', j.id);
        return u.toString();
      })
      .catch(function () { return long; });
    return Promise.race([req, new Promise(function (res) { setTimeout(function () { res(long); }, 3000); })]);
  }
  function buildLink(key, data) {
    var u = new URL(window.location.href);
    u.hash = '';
    ['konf', 'mhlive', 'mhre'].forEach(function (p) { u.searchParams.delete(p); });
    u.searchParams.set('konf', key + '.' + b64e(data));
    return u.toString();
  }

  var SVG = {
    wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.1.7a2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6 8.5-6"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="m8.2 10.8 7.6-4.4M8.2 13.2l7.6 4.4"/></svg>',
    save: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8M7 3v5h8"/></svg>'
  };

  function openSave(key) {
    var c = KONF[key], ad = adapters[key];
    var data = null;
    try { data = ad && ad.serialize ? ad.serialize() : null; } catch (e) { data = null; }
    /* 22.10.2026 (EP, Abnahme F8): E-Mail/PLZ nur abfragen, wenn sie wirklich verwendet werden
       (Klaviyo verbunden). Ohne Klaviyo: kein Kontaktfeld, nichts lokal gespeichert, ehrlicher Text. */
    var ASK = !!KLAVIYO_COMPANY;
    var ov = overlay(
      '<form class="mhks-box" novalidate role="dialog" aria-modal="true" aria-label="' + (ASK ? 'Planung speichern' : 'Link zur Planung erstellen') + '">' +
        '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>' +
        '<b class="mhks-t">' + (ASK ? 'Planung speichern &amp; teilen' : 'Link kopieren / teilen') + '</b>' +
        '<p class="mhks-p">' + (ASK ? 'Sie erhalten einen Link zu Ihrer ' + esc(c.name) + '-Planung' + (LINK_API ? ' per E-Mail' : '') + '. ' : 'Wir erstellen einen Link zu Ihrer ' + esc(c.name) + '-Planung. ') + 'Danach können Sie ihn kopieren oder per WhatsApp oder E-Mail weitergeben.</p>' +
        '<label class="mhks-l" for="mhksName">Name der Planung <small>(freiwillig)</small></label>' +
        '<input class="mhks-in" id="mhksName" type="text" name="pname" maxlength="60" autocomplete="off" placeholder="z. B. ' + (key === 'wpc' || key === 'terrassen' ? 'Terrasse hinterm Haus' : 'Zaun zum Nachbarn') + '">' +
        '<label class="mhks-l" for="mhksDesc">Beschreibung <small>(freiwillig)</small></label>' +
        '<textarea class="mhks-in" id="mhksDesc" name="pdesc" maxlength="300" rows="2" placeholder="Ihre Notizen, z. B. Maße noch prüfen, Farbe mit Nachbarn abstimmen"></textarea>' +
        (ASK ?
        '<div class="mhks-row">' +
          '<div><label class="mhks-l" for="mhksMail">E-Mail-Adresse</label>' +
          '<input class="mhks-in" id="mhksMail" type="email" name="email" autocomplete="email" inputmode="email" placeholder="name@beispiel.at" required></div>' +
          '<div><label class="mhks-l" for="mhksPlz">PLZ</label>' +
          '<input class="mhks-in" id="mhksPlz" type="text" name="plz" autocomplete="postal-code" inputmode="numeric" maxlength="4" placeholder="1234" required></div>' +
        '</div>' : '') +
        optinHtml(c.list) +
        '<div class="mhks-err" role="alert"></div>' +
        '<button type="submit" class="mhks-go">' + SVG.save + (ASK ? 'Planung speichern' : 'Link erstellen') + '</button>' +
        '<p class="mhks-note">' + (ASK
          ? (LINK_API ? 'Wir speichern Ihre Planung und E-Mail-Adresse 12 Monate auf unserem Server (Cloudflare), um den Link bereitzustellen. ' : 'Ihre Planung steckt vollständig im Link. ') + 'Mit Marketing-Einwilligung geht die Planung außerdem an unser E-Mail-Tool Klaviyo (USA). '
          : (LINK_API ? 'Für den kurzen Link speichern wir Ihre Planung mit Name und Beschreibung 12 Monate auf unserem Server (Cloudflare) – ohne Kontaktdaten. ' : 'Ihre Planung steckt vollständig im Link (inkl. Name und Beschreibung). Wir speichern dafür nichts auf einem Server und fragen keine Kontaktdaten ab. ')) + DS_LINK + '</p>' +
      '</form>');
    var form = ov.querySelector('form'), mail = ov.querySelector('#mhksMail'), plz = ov.querySelector('#mhksPlz'),
        ok = ov.querySelector('input[name="ok"]'), err = ov.querySelector('.mhks-err'),
        pname = ov.querySelector('#mhksName'), pdesc = ov.querySelector('#mhksDesc');
    if (loadedMeta && loadedMeta.key === key) { pname.value = loadedMeta.n || ''; pdesc.value = loadedMeta.d || ''; }
    if (ASK) { var prev = lsT('mhKonfPdfMail'); if (prev) mail.value = prev;
      var prevPlz = lsT('mhKonfPlz'); if (prevPlz) plz.value = prevPlz; }
    function fail(m) { err.textContent = m; err.classList.add('on'); }
    if (!data) fail('Die Planung ist noch nicht vollständig geladen – bitte warten Sie kurz und versuchen Sie es erneut.');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      try { data = ad && ad.serialize ? ad.serialize() : data; } catch (x) {}
      if (!data) { fail('Die Planung ist noch nicht vollständig geladen – bitte warten Sie kurz und versuchen Sie es erneut.'); return; }
      var email = ASK ? (mail.value || '').trim() : '', zip = ASK ? (plz.value || '').replace(/\s/g, '') : '';
      if (ASK) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail('Bitte geben Sie eine gültige E-Mail-Adresse ein.'); mail.focus(); return; }
        if (!/^\d{4,5}$/.test(zip)) { fail('Bitte geben Sie eine gültige Postleitzahl ein (4 Ziffern, in Deutschland 5).'); plz.focus(); return; }
        lsT('mhKonfPdfMail', email); lsT('mhKonfPlz', zip);
      }
      if (c.list) ls('mhKonfPdf:' + c.list, '1');
      var nm = (pname.value || '').replace(/\s+/g, ' ').trim().slice(0, 60), ds = (pdesc.value || '').trim().slice(0, 300);
      var longLink = buildLink(key, withMeta(data, nm, ds));
      loadedMeta = nm || ds ? { key: key, n: nm, d: ds } : null;
      var summary = '';
      try { summary = ad.summary ? ad.summary() : ''; } catch (x) {}
      if (ASK && ok.checked) kSubscribe(c.list, email, 'Konfigurator ' + c.name + ' - Gespeichert').catch(function (x) { try { console.warn('[Englputzeder] Klaviyo-Liste', x); } catch (e2) {} });
      var go = form.querySelector('.mhks-go');
      if (go) { go.disabled = true; go.lastChild.textContent = 'Link wird erstellt …'; }
      var meta = { n: nm, d: ds, sum: summary, page: window.location.pathname };
      if (ASK) { meta.plz = zip; meta.mail = email; meta.nl = ok.checked ? 1 : 0; }
      shortLink(longLink, meta).then(function (link) {
        if (ASK) kEvent(email, zip, { Konfigurator: c.name, Name: nm, Beschreibung: ds, Link: link, PLZ: zip, Zusammenfassung: summary, Seite: window.location.pathname, Newsletter: ok.checked ? 'ja' : 'nein' })
          .catch(function (x) { try { console.warn('[Englputzeder] Klaviyo-Ereignis', x); } catch (e2) {} });
        ov.__close();
        showShare(key, link, summary, nm);
      });
    });
    setTimeout(function () { try { if (ASK) (mail.value ? plz : mail).focus(); else pname.focus(); } catch (x) {} }, 30);
  }

  function showShare(key, link, summary, nm) {
    var c = KONF[key];
    var text = 'Meine ' + c.name + '-Planung' + (nm ? ' „' + nm + '“' : '') + ' bei Englputzeder' + (summary ? ' (' + summary + ')' : '') + ': ';
    var canShare = !!navigator.share;
    var ov = overlay(
      '<div class="mhks-box" role="dialog" aria-modal="true" aria-label="Planung teilen">' +
        '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>' +
        '<b class="mhks-t">' + (KLAVIYO_COMPANY || LINK_API ? (nm ? '„' + esc(nm) + '“ ist gespeichert' : 'Ihre Planung ist gespeichert') : (nm ? 'Ihr Link zu „' + esc(nm) + '“' : 'Ihr Link zur Planung')) + '</b>' +
        '<div class="mhks-ok"><span>✓</span><span>' + 'Mit diesem Link öffnen Sie Ihre Planung jederzeit wieder' + (KLAVIYO_COMPANY && marketingOk() ? ' – wir schicken ihn Ihnen auch per E-Mail.' : '. Bitte speichern Sie ihn oder teilen Sie ihn sich selbst.') + '</span></div>' +
        '<div class="mhks-link"><input type="text" readonly value="' + esc(link) + '" aria-label="Link zur Planung"></div>' +
        '<div class="mhks-share">' +
          '<a class="mhks-sh mhks-sh--wa" target="_blank" rel="noopener" href="https://wa.me/?text=' + encodeURIComponent(text + link) + '">' + SVG.wa + 'WhatsApp</a>' +
          '<a class="mhks-sh" href="mailto:?subject=' + encodeURIComponent('Meine ' + c.name + '-Planung bei Englputzeder') + '&body=' + encodeURIComponent(text + '\n' + link) + '">' + SVG.mail + 'E-Mail</a>' +
          '<button type="button" class="mhks-sh" data-mhks-copy>' + SVG.copy + '<span>Link kopieren</span></button>' +
          (canShare ? '<button type="button" class="mhks-sh" data-mhks-native>' + SVG.share + 'Weiterleiten</button>' : '') +
        '</div>' +
        '<p class="mhks-note">Der Link öffnet Ihre Planung mit dem Stand von jetzt. Wer ihn öffnet, sieht genau diesen Stand und kann ihn weiter anpassen. Ändern Sie danach noch etwas, speichern Sie einfach erneut – Sie erhalten dann einen neuen Link, der alte bleibt unverändert. Beim Teilen über WhatsApp erhält Meta den Link/das Bild.</p>' +
      '</div>');
    var inp = ov.querySelector('.mhks-link input');
    inp.addEventListener('focus', function () { inp.select(); });
    ov.querySelector('[data-mhks-copy]').addEventListener('click', function (e) {
      var b = e.currentTarget, sp = b.querySelector('span');
      function done() { sp.textContent = 'Kopiert ✓'; setTimeout(function () { sp.textContent = 'Link kopieren'; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { inp.select(); document.execCommand('copy'); done(); });
      else { inp.select(); try { document.execCommand('copy'); } catch (x) {} done(); }
    });
    var nb = ov.querySelector('[data-mhks-native]');
    if (nb) nb.addEventListener('click', function () {
      navigator.share({ title: 'Meine ' + c.name + '-Planung', text: text, url: link }).catch(function () {});
    });
  }

  /* ---------- 6. Planung exportieren: E-Mail vor dem PDF ----------
     Die Export-Links der Konfiguratoren bleiben unveraendert - der Klick wird hier in der
     Capture-Phase abgefangen, erst nach gueltiger E-Mail-Adresse wird er erneut ausgeloest
     (noch innerhalb der Nutzergeste, damit das PDF-Fenster nicht als Pop-up blockiert wird). */
  var EXPORT_SEL = '#shareLink,[data-mhzk-pdf],[data-mhds-pdf]';
  var BERATUNG_SEL = 'a[href*="termin.englputzeder"],a[href*="/pages/beratung"]';
  function openExport(key, el) {
    var c = KONF[key];
    var ov = overlay(
      '<form class="mhks-box" novalidate role="dialog" aria-modal="true" aria-label="Planung exportieren">' +
        '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>' +
        '<b class="mhks-t">Planung exportieren</b>' +
        '<p class="mhks-p">Ihre ' + esc(c.name) + '-Planung öffnet sich als Übersicht mit Plan, Produkten und Preisen, die Sie als PDF speichern können.</p>' +
        (KLAVIYO_COMPANY ? '<label class="mhks-l" for="mhksXMail">E-Mail-Adresse <small>(optional – wenn Sie den Link per E-Mail möchten)</small></label>' +
        '<input class="mhks-in" id="mhksXMail" type="email" name="email" autocomplete="email" inputmode="email" placeholder="name@beispiel.at">' : '<input id="mhksXMail" type="hidden" name="email" value="">') +
        optinHtml(c.list) +
        '<div class="mhks-err" role="alert"></div>' +
        '<button type="submit" class="mhks-go">Planung als PDF öffnen</button>' +
      '</form>');
    var form = ov.querySelector('form'), mail = ov.querySelector('#mhksXMail'),
        ok = ov.querySelector('input[name="ok"]'), err = ov.querySelector('.mhks-err');
    var prev = lsT('mhKonfPdfMail'); if (prev && KLAVIYO_COMPANY) mail.value = prev;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      /* 13.10.2026: Sicherheits-Review – E-Mail freiwillig; ohne E-Mail direkt exportieren, kein Klaviyo */
      var email = (mail.value || '').trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Bitte geben Sie eine gültige E-Mail-Adresse ein – oder lassen Sie das Feld leer.'; err.classList.add('on'); mail.focus(); return; }
      if (!email && ok.checked) { err.textContent = 'Für den Newsletter benötigen wir Ihre E-Mail-Adresse.'; err.classList.add('on'); mail.focus(); return; }
      if (email) lsT('mhKonfPdfMail', email);
      var summary = '', ad = adapters[key];
      try { summary = ad && ad.summary ? ad.summary() : ''; } catch (x) {}
      if (email && ok.checked) kSubscribe(c.list, email, 'Konfigurator ' + c.name + ' - PDF').catch(function (x) { try { console.warn('[Englputzeder] Klaviyo-Liste', x); } catch (e2) {} });
      kEvent(email, '', { Konfigurator: c.name, Zusammenfassung: summary, Seite: window.location.pathname, Newsletter: ok.checked ? 'ja' : 'nein' }, 'Planung exportiert')
        .catch(function (x) { try { console.warn('[Englputzeder] Klaviyo-Ereignis', x); } catch (e2) {} });
      ov.__close();
      /* WPC und Terrassenplatten: "Als PDF öffnen" liefert den Detailplan (zweiter, von
         mh-konf-pdf-gate.js ausgeblendeter Link auf derselben Karte) */
      var target = el;
      if (key === 'wpc' || key === 'terrassen') {
        var card = el.closest('.extra'), as = card ? card.querySelectorAll('a') : [];
        for (var i = 0; i < as.length; i++) if (as[i] !== el && /^\s*Detailplan/.test(as[i].textContent || '')) { target = as[i]; break; }
      }
      target.__mhksPass = true;
      try { target.click(); } finally { target.__mhksPass = false; }
    });
    setTimeout(function () { try { (KLAVIYO_COMPANY ? mail : form.querySelector('.mhks-go')).focus(); } catch (x) {} }, 30);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest(EXPORT_SEL) : null;
    if (!a || a.__mhksPass) return;
    var k = keyOf(a);
    if (!k) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    openExport(k, a);
  }, true);

  /* ---------- 8. Beratung angeklickt (Klaviyo) ----------
     Die Beratung selbst laeuft ueber die Terminbuchung. Hier wird nur der Klick festgehalten.
     13.10.2026: Sicherheits-Review – nur mit Marketing-Einwilligung und ohne die gespeicherte E-Mail:
     ueber klaviyo.js, das den Besucher nur kennt, wenn er schon einmal identifiziert wurde.
     Unbekannte Besucher erzeugen kein Ereignis. */
  function trackBeratung(key, quelle) {
    if (!KLAVIYO_COMPANY || !marketingOk()) return;
    var c = KONF[key] || {};
    var props = { Konfigurator: c.name || key, Seite: window.location.pathname, Quelle: quelle };
    try {
      if (typeof window.MH_KLAVIYO_TEST === 'function') { window.MH_KLAVIYO_TEST('onsite-track', props); return; }
      if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Beratung angeklickt', props]);
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest(BERATUNG_SEL) : null;
    if (!a) return;
    var hint = a.getAttribute('data-mhks-beratung'), k = hint || keyOf(a);
    if (!k || !KONF[k]) return;
    trackBeratung(k, hint ? 'Hinweis nach 60 s' : 'Karte');
  }, true);

  /* ---------- 7. Feedback abgeben ---------- */
  /* 22.10.2026 (EP): Feedback-Worker aus EP_KONF_CFG.live (Fallback MH_WPC_LIVE.endpoint); leer = keine Feedback-Karte */
  var FB_EP = String(CFG.live || '');
  try { if (!FB_EP && window.MH_WPC_LIVE && window.MH_WPC_LIVE.endpoint) FB_EP = String(window.MH_WPC_LIVE.endpoint); } catch (e) {}
  FB_EP = FB_EP.trim().replace(/\/+$/, '');
  var FB_KONF = { zaun: 'sichtschutz', doppelstab: 'doppelstab', terrassen: 'terrassen', wpc: 'wpc', pergola: 'pergola' };
  var FB_Q = {
    konf: [['sichtschutz', 'Sichtschutzzaun'], ['doppelstab', 'Doppelstabmattenzaun'], ['terrassen', 'Terrassenplatten'], ['wpc', 'WPC-Dielen'], ['pergola', 'Pergola']],
    gefunden: [['ja', 'Ja'], ['teilweise', 'Teilweise'], ['nein', 'Nein']],
    probleme: [['handy', 'Bedienung am Handy'], ['produkt', 'Produkt oder Maß fehlt'], ['preise', 'Preise unklar'], ['schritte', 'Zu viele Schritte'],
               ['ansicht', '3D- / Live-Ansicht'], ['montage', 'Montage unklar'], ['lieferung', 'Lieferung / Versand'], ['sonstiges', 'Sonstiges']],
    weiter: [['bestellt', 'Ich habe bereits bestellt'], ['bald', 'Ich bestelle bald'], ['spaeter', 'Später'], ['vergleich', 'Ich vergleiche noch'], ['nein', 'Eher nicht']]
  };
  var FB_STARS = ['', 'gar nicht zufrieden', 'eher unzufrieden', 'geht so', 'zufrieden', 'sehr zufrieden'];
  var FB_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M8 9h8M8 13h5"/></svg>';

  function fbChips(name, list, multi) {
    return '<div class="mhks-chips" data-fb-group="' + name + '"' + (multi ? ' data-fb-multi="1"' : '') + '>'
      + list.map(function (o) { return '<button type="button" class="mhks-chip" aria-pressed="false" data-fb-val="' + o[0] + '">' + esc(o[1]) + '</button>'; }).join('')
      + '</div>';
  }
  function fbStep(root) {
    if (!root) return '';
    var el = root.querySelector('[aria-current="step"],[aria-selected="true"],.is-active[data-step],.active[data-step],.mhds-tab.on,.mhzk-tab.on,.step.active,.tab.active');
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) : '';
  }
  /* Formular bauen - im PopUp (Konfigurator bekannt) oder auf der Seite (Konfigurator waehlbar) */
  function fbForm(key, inline) {
    return '<form class="mhks-box" novalidate role="dialog"' + (inline ? '' : ' aria-modal="true"') + ' aria-label="Feedback abgeben">' +
      (inline ? '' : '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>') +
      '<div class="mhks-fb-ic">' + FB_IC + '</div>' +
      '<b class="mhks-t">Feedback abgeben</b>' +
      '<p class="mhks-p">Wir wollen uns weiterentwickeln – sagen Sie uns in einer Minute, was an ' + (key && KONF[key] ? 'unserem ' + esc(KONF[key].name) + '-Konfigurator' : 'unseren Konfiguratoren') + ' gut ist und was wir besser machen können. Jede Frage ist freiwillig.</p>' +
      (key ? '' : '<fieldset class="mhks-fb-q"><legend>Welchen Konfigurator haben Sie genutzt?</legend>' + fbChips('konf', FB_Q.konf) + '</fieldset>') +
      '<fieldset class="mhks-fb-q"><legend>Wie zufrieden sind Sie mit dem Konfigurator?</legend><div class="mhks-stars" data-fb-group="zufrieden">'
        + [1, 2, 3, 4, 5].map(function (n) { return '<button type="button" class="mhks-star" data-fb-val="' + n + '" aria-label="' + n + ' von 5 – ' + FB_STARS[n] + '">★</button>'; }).join('')
        + '<span class="mhks-stars__lbl" aria-live="polite"></span></div></fieldset>' +
      '<fieldset class="mhks-fb-q"><legend>Haben Sie gefunden, was Sie gesucht haben?</legend>' + fbChips('gefunden', FB_Q.gefunden) + '</fieldset>' +
      '<fieldset class="mhks-fb-q"><legend>Was war schwierig oder hat gefehlt? <small>(mehrere möglich)</small></legend>' + fbChips('probleme', FB_Q.probleme, true) + '</fieldset>' +
      '<fieldset class="mhks-fb-q"><legend>Wie geht es bei Ihnen weiter?</legend>' + fbChips('weiter', FB_Q.weiter) + '</fieldset>' +
      '<div class="mhks-fb-q"><label class="mhks-l" for="mhksFbText">Was sollen wir besser machen?</label>' +
        '<textarea class="mhks-in" id="mhksFbText" name="text" maxlength="2000" placeholder="Ihr Vorschlag, eine Idee oder was Sie gestört hat …"></textarea></div>' +
      '<fieldset class="mhks-fb-q"><legend>Dürfen wir bei Rückfragen auf Sie zukommen? <small>(freiwillig)</small></legend>' +
        '<div class="mhks-row mhks-row--2">' +
          '<div><label class="mhks-l" for="mhksFbMail">E-Mail</label>' +
          '<input class="mhks-in" id="mhksFbMail" type="email" name="email" autocomplete="email" inputmode="email" placeholder="name@beispiel.at" style="margin:0"></div>' +
          '<div><label class="mhks-l" for="mhksFbTel">Telefon</label>' +
          '<input class="mhks-in" id="mhksFbTel" type="tel" name="telefon" autocomplete="tel" inputmode="tel" placeholder="+43 …" maxlength="30" style="margin:0"></div>' +
        '</div></fieldset>' +
      '<div class="mhks-hp" aria-hidden="true"><label>Website<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
      '<div class="mhks-err" role="alert"></div>' +
      '<button type="submit" class="mhks-go">Feedback senden</button>' +
      '<p class="mhks-note">Ihre Angaben gehen an unseren Server (Cloudflare) zur Auswertung. Ihr Feedback ist anonym, solange Sie keine E-Mail-Adresse oder Telefonnummer angeben – Kontaktdaten nutzen wir nur für Rückfragen. ' + (KLAVIYO_COMPANY ? 'Mit Marketing-Einwilligung und E-Mail-Adresse geht eine Kurzfassung (ohne Freitext und Telefon) auch an unser E-Mail-Tool Klaviyo (USA). ' : '') + 'Mehr in der ' + DS_LINK + '.</p>' +
    '</form>';
  }
  function fbWire(host, key, inline, onDone) {
    var form = host.querySelector('form'), err = host.querySelector('.mhks-err'), t0 = Date.now(), busy = false;
    var ans = { zufrieden: 0, gefunden: '', probleme: [], weiter: '', konf: key ? FB_KONF[key] : '' };
    form.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-fb-val]') : null;
      if (!b || !form.contains(b)) return;
      var g = b.parentNode, name = g.getAttribute('data-fb-group'), v = b.getAttribute('data-fb-val');
      err.classList.remove('on');
      if (name === 'zufrieden') {
        ans.zufrieden = +v;
        [].forEach.call(g.querySelectorAll('.mhks-star'), function (s) { var on = +s.getAttribute('data-fb-val') <= ans.zufrieden; s.classList.toggle('on', on); s.setAttribute('aria-pressed', String(+s.getAttribute('data-fb-val') === ans.zufrieden)); });
        g.querySelector('.mhks-stars__lbl').textContent = FB_STARS[ans.zufrieden];
        return;
      }
      if (g.getAttribute('data-fb-multi')) {
        var i = ans[name].indexOf(v);
        if (i >= 0) ans[name].splice(i, 1); else ans[name].push(v);
        b.setAttribute('aria-pressed', String(i < 0));
        return;
      }
      var same = ans[name] === v;
      ans[name] = same ? '' : v;   /* erneuter Klick hebt die Auswahl auf */
      [].forEach.call(g.querySelectorAll('[data-fb-val]'), function (x) { x.setAttribute('aria-pressed', String(!same && x === b)); });
    });
    var mail = form.querySelector('[name="email"]'), tel = form.querySelector('[name="telefon"]'), text = form.querySelector('[name="text"]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var email = (mail.value || '').trim(), phone = (tel.value || '').trim(), txt = (text.value || '').trim();
      function fail(m) { err.textContent = m; err.classList.add('on'); }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail('Bitte prüfen Sie Ihre E-Mail-Adresse – oder lassen Sie das Feld einfach leer.'); mail.focus(); return; }
      if (phone && !/^\+?[0-9][0-9 ()\/.\-]{4,28}$/.test(phone)) { fail('Bitte prüfen Sie Ihre Telefonnummer – oder lassen Sie das Feld einfach leer.'); tel.focus(); return; }
      if (!ans.zufrieden && !ans.gefunden && !ans.probleme.length && !ans.weiter && !txt) { fail('Bitte beantworten Sie mindestens eine Frage.'); return; }
      if (!FB_EP && typeof window.MH_FEEDBACK_TEST !== 'function') { fail('Das Feedback ist gerade nicht verfügbar. Schreiben Sie uns gerne an ' + KONTAKT + '.'); return; }
      var ad = key ? adapters[key] : null, root = key && KONF[key] ? rootOf(key, false) : null, summary = '';
      try { summary = ad && ad.summary ? ad.summary() : ''; } catch (x) {}
      var q = new URLSearchParams(window.location.search);
      var payload = {
        quelle: inline ? 'seite' : 'popup', konf: ans.konf, zufrieden: ans.zufrieden || null, gefunden: ans.gefunden,
        probleme: ans.probleme, weiter: ans.weiter, text: txt, email: email, telefon: phone, rueckfrage: !!(email || phone),
        website: (form.querySelector('[name="website"]') || {}).value || '', dauer: Math.round((Date.now() - t0) / 1000),
        ctx: {
          schritt: fbStep(root),
          geraet: (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) || window.innerWidth < 768 ? 'mobil' : 'desktop',
          planung: String(summary || '').slice(0, 300),
          seite: (window.location.pathname + (q.get('view') ? '?view=' + q.get('view') : '')).slice(0, 200)
        }
      };
      busy = true;
      var go = form.querySelector('.mhks-go'); go.disabled = true; go.textContent = 'Wird gesendet …';
      /* window.MH_FEEDBACK_TEST(payload) ersetzt beim Testen den Versand (liefert ein Promise auf eine Response) */
      (typeof window.MH_FEEDBACK_TEST === 'function' ? window.MH_FEEDBACK_TEST(payload)
        : nativeFetch(FB_EP + '/feedback', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }))
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || r.status); }); })
        .then(function () {
          ls('mhKonfFb', String(Date.now()));
          /* 13.10.2026: Sicherheits-Review – Freitext/Telefon nur an den Worker; Klaviyo nur mit Consent (kEvent) */
          if (email) {
            var lab = function (list, v) { for (var i = 0; i < list.length; i++) if (list[i][0] === v) return list[i][1]; return v || ''; };
            kEvent(email, '', {
              Konfigurator: lab(FB_Q.konf, ans.konf), Quelle: inline ? 'Seite' : 'PopUp',
              Zufriedenheit: ans.zufrieden || '', Gefunden: lab(FB_Q.gefunden, ans.gefunden),
              Probleme: ans.probleme.map(function (p) { return lab(FB_Q.probleme, p); }).join(', '),
              'Wie weiter': lab(FB_Q.weiter, ans.weiter),
              Zusammenfassung: payload.ctx.planung, Seite: payload.ctx.seite
            }, 'Konfigurator Feedback').catch(function (x) { try { console.warn('[Englputzeder] Klaviyo-Ereignis', x); } catch (e2) {} });
          }
          form.innerHTML = (inline ? '' : '<button type="button" class="mhks-x" data-mhks-close aria-label="Schließen">✕</button>') +
            '<div class="mhks-fb-ic">' + FB_IC + '</div><b class="mhks-t">Danke für Ihr Feedback!</b>' +
            '<div class="mhks-ok"><span>✓</span><span>Wir lesen jede Antwort und nutzen sie, um die Konfiguratoren weiter zu verbessern.' + (email || phone ? ' Falls wir Fragen haben, melden wir uns bei Ihnen.' : '') + '</span></div>' +
            (inline ? '' : '<button type="button" class="mhks-go" data-mhks-close>Weiter planen</button>');
          if (onDone) onDone();
        })
        .catch(function (x) {
          busy = false; go.disabled = false; go.textContent = 'Feedback senden';
          fail(String(x && x.message) === 'rate_limited' ? 'Sie haben gerade schon mehrfach Feedback gesendet – danke! Bitte versuchen Sie es später noch einmal.'
            : 'Das Senden hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder schreiben Sie uns an ' + KONTAKT + '.');
        });
    });
  }
  function openFeedback(key) {
    var ov = overlay(fbForm(key, false));
    fbWire(ov, key, false);
  }
  /* Seite ?view=feedback: Formular direkt in einen Container */
  function feedbackInline(host, key) {
    if (!host || host.getAttribute('data-mhks-fb-done')) return;
    host.setAttribute('data-mhks-fb-done', '1');
    ensureCss();
    var k = key && KONF[key] ? key : null;
    if (!k) { try { var p = new URLSearchParams(window.location.search).get('k'); if (p && KONF[p]) k = p; } catch (e) {} }
    host.innerHTML = '<div class="mhks-ov mhks-ov--inline">' + fbForm(k, true) + '</div>';
    fbWire(host, k, true);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mhks-fb]') : null;
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    openFeedback(a.getAttribute('data-mhks-fb'));
  }, true);

  /* Reihenfolge der Karten: 1 Planung exportieren, 2 Speichern & teilen, 3 Lieber persoenlich?, 4 Feedback -
     nur umsortieren, wenn noetig (sonst wuerde der MutationObserver endlos neu ausloesen). */
  function orderCards(box) {
    var kids = [].slice.call(box.children);
    function find(sel) { for (var i = 0; i < kids.length; i++) if (kids[i].querySelector(sel)) return kids[i]; return null; }
    var want = [find(EXPORT_SEL), find('[data-mhks-save]'), find(BERATUNG_SEL), find('[data-mhks-fb]')].filter(Boolean);
    var rest = kids.filter(function (k) { return want.indexOf(k) < 0; });
    var order = want.concat(rest);
    for (var i = 0; i < order.length; i++) if (kids[i] !== order[i]) { order.forEach(function (n) { box.appendChild(n); }); return; }
  }

  /* Karte "Speichern & teilen" neben "Planung exportieren" einsetzen */
  function injectCards() {
    KEYS.forEach(function (k) {
      var c = KONF[k];
      var roots = document.querySelectorAll(c.root);
      for (var i = 0; i < roots.length; i++) {
        var box = roots[i].querySelector(c.card);
        if (!box) continue;
        if (box.querySelector('[data-mhks-save]') && (!FB_EP || box.querySelector('[data-mhks-fb]'))) { orderCards(box); continue; }
        var zaunlike = k === 'zaun' || k === 'doppelstab';
        var mk = function (title, text, link) {
          var card = document.createElement('div');
          card.className = (zaunlike ? (k === 'zaun' ? 'mhzk-extra' : 'mhds-extra') : 'extra') + ' mhks-card';
          card.innerHTML = '<b>' + title + '</b>'
            + (zaunlike ? '<span>' + text + '</span>' : '<span style="color:var(--mhk-ink-soft)">' + text + '</span><br>')
            + link;
          box.appendChild(card);
        };
        if (!box.querySelector('[data-mhks-save]'))
          (KLAVIYO_COMPANY ? mk('Speichern &amp; teilen', 'Planung sichern, per WhatsApp oder E-Mail weitergeben', '<a href="#" data-mhks-save="' + k + '">Speichern &amp; teilen →</a>') : mk('Link kopieren / teilen', 'Link zur Planung erstellen, kopieren oder per WhatsApp/E-Mail weitergeben', '<a href="#" data-mhks-save="' + k + '">Link erstellen →</a>'));
        if (FB_EP && !box.querySelector('[data-mhks-fb]'))
          mk('Feedback abgeben', 'Wir wollen uns weiterentwickeln – sagen Sie uns, was wir besser machen können', '<a href="#" data-mhks-fb="' + k + '">Feedback geben →</a>');
        orderCards(box);
      }
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mhks-save]') : null;
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    openSave(a.getAttribute('data-mhks-save'));
  }, true);

  /* ---------- 4. Wiederherstellen aus dem Link ---------- */
  function waitFor(fn, ms) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function tick() {
        var v = null;
        try { v = fn(); } catch (e) { v = null; }
        if (v) return res(v);
        if (Date.now() - t0 > ms) return rej(new Error('timeout'));
        setTimeout(tick, 150);
      })();
    });
  }
  function restoreFromUrl() {
    var q = null, k = null;
    try { q = new URLSearchParams(window.location.search).get('konf'); k = new URLSearchParams(window.location.search).get('k'); } catch (e) { q = null; }
    if (!q && k && LINK_API && /^[0-9A-Za-z]{8,12}$/.test(k)) {   /* kurzer Link: Planung beim Worker abholen */
      fetch(LINK_API + '/s/' + k).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (j && typeof j.konf === 'string') restoreKonf(j.konf);
        else toast('Diese Planung wurde nicht gefunden', 'Der Link ist abgelaufen oder unvollständig.');
      }).catch(function (e) { try { console.warn('[Englputzeder] Planung konnte nicht geladen werden', e); } catch (x) {} });
      return;
    }
    if (q) restoreKonf(q);
  }
  function restoreKonf(q) {
    var dot = q.indexOf('.');
    if (dot < 1) return;
    var key = q.slice(0, dot), data;
    if (!KONF[key]) return;
    try { data = b64d(q.slice(dot + 1)); } catch (e) { return; }
    var c = KONF[key], meta = null;
    if (data && data._m && typeof data._m === 'object') { meta = { key: key, n: String(data._m.n || '').slice(0, 60), d: String(data._m.d || '').slice(0, 300) }; delete data._m; }
    var re = null;
    try { re = new URLSearchParams(window.location.search).get('mhre'); } catch (e) { re = null; }
    if (re && /^[A-Za-z0-9-]{4,40}$/.test(re)) ss('mhKonfReplace', JSON.stringify({ key: key, id: re }));
    waitFor(function () { return rootOf(key, false); }, 15000).then(function (root) {
      var modal = c.modal ? document.getElementById(c.modal) : null;
      if (modal && modal.contains(root) && !modal.classList.contains('is-open')) {
        var b = document.getElementById(c.open);
        if (b) b.click();
      }
      return waitFor(function () { var ad = adapters[key]; return ad && (!ad.ready || ad.ready()) ? ad : null; }, 20000);
    }).then(function (ad) {
      ad.restore(data);
      loadedMeta = meta;
      if (meta && (meta.n || meta.d)) toast(meta.n ? 'Planung „' + meta.n + '“ geöffnet' : 'Ihre Planung ist geöffnet', meta.d);
      else if (re) toast('Ihre Planung ist geöffnet', 'Ändern Sie, was Sie möchten – beim erneuten Hinzufügen ersetzen wir die Positionen im Warenkorb.');
    }).catch(function (e) { try { console.warn('[Englputzeder] Planung konnte nicht geladen werden', e); } catch (x) {} });
  }

  /* ---------- 16. Sichtschutz: nach Weiter/Zurueck zum Schrittanfang (30.09.2026) ----------
     Am Handy liegt die Bedienung unter der Vorschau - nach "Weiter" blieb die Seite unten
     stehen. Im PopUp der Produktseite scrollt der Konfigurator selbst den Dialog. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.mhzk-nav__next,.mhzk-nav__back') : null;
    if (!b) return;
    var root = b.closest('.mhzk-app');
    if (!root || root.closest('.mhtk-modal__dialog')) return;
    setTimeout(function () {
      var t = root.querySelector('.mhzk-steps') || root, r = t.getBoundingClientRect();
      if (r.top < 70 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - 90), behavior: 'smooth' });
    }, 60);
  }, true);

  /* ---------- 15. Produktseite: Badge "Traum... konfigurieren" ---------- */
  var PB = {
    doppelstab: { t: 'Ihren Wunschzaun konfigurieren', link: '/pages/doppelstabmattenzaun-konfigurator' },
    zaun: { t: 'Ihren Wunschzaun konfigurieren', link: '/pages/sichtschutzzaun-konfigurator' },
    wpc: { t: 'Ihre Traumterrasse konfigurieren', link: '/pages/wpc-dielen-konfigurator' },
    terrassen: { t: 'Ihre Traumterrasse konfigurieren', link: '/pages/terrassenplatten-konfigurator' }
  };
  function pdpTyp() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta, pr = m && m.product;
    if (!(m && m.page && m.page.pageType === 'product') && !/\/products\//.test(window.location.pathname)) return '';
    var h = (window.location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
    var k = (h + ' ' + (pr && pr.type || '') + ' ' + txt(document.querySelector('h1'))).toLowerCase();
    if (/muster|probe|sample/.test(k)) return '';
    if (/doppelstab/.test(k)) return 'doppelstab';
    if (/sichtschutz/.test(k)) return 'zaun';
    if (/wpc/.test(k) && /diele|terrass/.test(k)) return 'wpc';
    if (/terrassenplatte|feinsteinzeug|keramikplatte|keramik-terrasse/.test(k)) return 'terrassen';
    return '';
  }
  var pbDone = false;
  function injectBadge() {
    if (pbDone) return;
    if (CFG.badge === false) { pbDone = true; return; }   /* 22.10.2026 (EP): abschaltbar ueber EP_KONF_CFG.badge */
    var typ = pdpTyp(); if (!typ) { pbDone = true; return; }
    var h1 = document.querySelector('main h1.product-title, main h1, h1'); if (!h1) return;
    pbDone = true;
    if (document.querySelector('.mhks-pb')) return;
    var c = PB[typ];
    var a = document.createElement('a');
    a.className = 'mhks-pb'; a.href = c.link;
    a.innerHTML = '<i><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15.5l-1.9-4.6L5.5 9l4.6-1.4z"/><path d="M19 15l.8 2 2 .8-2 .8L19 21l-.8-2.2-2-.8 2-.8z"/></svg></i><span>' + esc(c.t) + ' <small>· kostenlos</small></span>';
    a.addEventListener('click', function (e) {
      var r0 = rootOf(typ, true);
      if (r0) { e.preventDefault(); window.scrollTo({ top: Math.max(0, window.pageYOffset + r0.getBoundingClientRect().top - 80), behavior: 'smooth' }); return; }
      var ob = document.getElementById(KONF[typ].open);
      if (ob) { e.preventDefault(); ob.click(); }   /* Konfigurator-PopUp auf der Produktseite */
    });
    var host = h1.parentNode;
    host.insertBefore(a, h1.nextSibling);
  }

  /* ---------- 14. Live ansehen: per WhatsApp senden ---------- */
  function planLink(key) {
    var ad = adapters[key], d = null;
    try { d = ad && ad.serialize ? ad.serialize() : null; } catch (e) { d = null; }
    return d ? buildLink(key, withMeta(d, loadedMeta && loadedMeta.key === key ? loadedMeta.n : '', loadedMeta && loadedMeta.key === key ? loadedMeta.d : '')) : window.location.href;
  }
  /* Ergebnisbild der Live-Ansicht als Canvas (WPC/Terrassen: data-URL am Download-Link, sonst groesstes Bild im Dialog) */
  function liveCanvas(box, dl) {
    var h = dl && dl.getAttribute('href');
    if (h && /^data:image\//.test(h)) return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight; c.getContext('2d').drawImage(im, 0, 0); res(c); };
      im.onerror = rej; im.src = h;
    });
    var best = null;
    [].forEach.call(box.querySelectorAll('canvas,img'), function (el) { var r = el.getBoundingClientRect(), a = r.width * r.height; if (a > 20000 && (!best || a > best.a)) best = { el: el, a: a }; });
    if (!best) return Promise.reject(new Error('kein Bild'));
    var el = best.el;
    if (el.tagName.toLowerCase() === 'canvas') return Promise.resolve(el);
    var c = document.createElement('canvas'); c.width = el.naturalWidth; c.height = el.naturalHeight; c.getContext('2d').drawImage(el, 0, 0);
    return Promise.resolve(c);
  }
  function toBlobP(cv, type) { return new Promise(function (res, rej) { try { cv.toBlob(function (b) { b ? res(b) : rej(new Error('leer')); }, type, 0.9); } catch (e) { rej(e); } }); }
  /* 01.10.2026: "Per WhatsApp senden" verschickt das Bild selbst (kein Planungs-Link).
     Mit Teilen-Menue (Handy, Mac-Safari): Bild direkt an WhatsApp. Sonst (Windows/Chrome am Desktop):
     Bild in die Zwischenablage kopieren und herunterladen, WhatsApp Web oeffnen - dort einfuegen. */
  /* "Keine ausgewählt": Safari zeigt beim unsichtbaren Datei-Feld ueber der Foto-Auswahl (WPC/Terrassen)
     seinen Standard-Hinweis - und laesst ihn stehen, wenn danach "Bild wird analysiert" erscheint.
     Das Feld nimmt deshalb keine Maus mehr an; ein Klick auf die Flaeche oeffnet die Auswahl. */
  document.addEventListener('click', function (e) {
    var d = e.target && e.target.closest ? e.target.closest('.mh-live-drop') : null;
    if (!d) return;
    var i = d.querySelector('input[type="file"]');
    if (i && !i.disabled && e.target !== i) i.click();
  });
  function injectWa() {
    /* WPC/Terrassen: #liveDl ("Bild herunterladen"); Doppelstab/Sichtschutz: [data-dl] ("Bild speichern") */
    var dls = document.querySelectorAll('#liveDl,[data-dl],.mhdx-foot a,.mhdx-foot button,.mhzk-ov a,.mhzk-ov button');
    [].forEach.call(dls, function (dl) {
      if (dl.id !== 'liveDl' && !dl.hasAttribute('data-dl') && !/Bild (herunterladen|speichern)/.test(dl.textContent || '')) return;
      if (!dl.parentNode || dl.parentNode.querySelector('.mhks-wa')) return;
      var box = dl.closest('.mh-live-box,.mh-live,.mhdx-box,.mhzk-ov__box,.mhzk-ov,[role="dialog"]') || dl.parentNode.parentNode || document.body;
      var key = (active() || {}).key || (document.getElementById('mhKonfRoot') ? 'terrassen' : 'wpc');
      if (dl.closest('.mhdx-ov,.mhdx-box')) key = 'doppelstab';
      if (dl.closest('.mhzk-ov')) key = 'zaun';
      var zaun = key === 'zaun' || key === 'doppelstab';
      var fname = 'Englputzeder-' + (zaun ? 'Zaun' : 'Terrasse') + '.jpg';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mhks-wa'; b.innerHTML = SVG.wa + 'Per WhatsApp senden';
      /* Bild vorbereiten und aktuell halten: navigator.share / Zwischenablage muessen direkt im Klick laufen */
      function prep() {
        if (!b.isConnected) { clearInterval(b.__t); return; }
        liveCanvas(box, dl).then(function (cv) {
          toBlobP(cv, 'image/jpeg').then(function (bl) { try { b.__file = new File([bl], fname, { type: 'image/jpeg' }); } catch (e) { b.__file = bl; } });
          toBlobP(cv, 'image/png').then(function (bl) { b.__png = bl; });
        }).catch(function () {});
      }
      setTimeout(prep, 300); b.__t = setInterval(prep, 2500);
      function perWeb() {
        var f = b.__file, copied = false;
        try {
          if (b.__png && navigator.clipboard && window.ClipboardItem) { navigator.clipboard.write([new ClipboardItem({ 'image/png': b.__png })]).catch(function () {}); copied = true; }
        } catch (e) { copied = false; }
        try {
          if (f) { var a = document.createElement('a'); a.href = URL.createObjectURL(f); a.download = fname; document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500); }
          else dl.click();
        } catch (e) {}
        var w = window.open('https://web.whatsapp.com/', '_blank');
        if (w) { try { w.opener = null; } catch (e) {} }
        toast('WhatsApp wird geöffnet', (copied ? 'Das Bild ist kopiert – wählen Sie den Chat und fügen Sie es mit Strg+V bzw. ⌘+V ein. ' : 'Wählen Sie den Chat und hängen Sie das Bild an. ') + 'Es wurde zusätzlich heruntergeladen.');
      }
      b.addEventListener('click', function () {
        var f = b.__file;
        if (f && navigator.canShare && navigator.canShare({ files: [f] })) {
          navigator.share({ files: [f] }).catch(function (err) { if (!(err && err.name === 'AbortError')) perWeb(); });
          return;
        }
        perWeb();
      });
      dl.parentNode.insertBefore(b, dl.nextSibling);
    });
  }

  /* ---------- 11. Mini-Vorschau ---------- */
  var MINI = {
    doppelstab: { box: '.mhds-stage', src: '[data-r="front"]' },
    wpc: { box: '#planbox', src: '#planbox' },
    terrassen: { box: '#planbox', src: '#planbox' },
    zaun: { box: '[data-mhzk-preview]', src: '[data-mhzk-preview]' }
  };
  var mini = null, miniKey = null, miniOff = false, miniRaf = 0, miniT = 0;
  function miniEl() {
    if (mini) return mini;
    ensureCss();
    mini = document.createElement('div');
    mini.className = 'mhks-mini'; mini.setAttribute('role', 'button'); mini.setAttribute('aria-label', 'Zur Vorschau springen');
    mini.innerHTML = '<div class="mhks-mini__img"></div><div class="mhks-mini__bar">Ihre Planung <span>↑ Vorschau</span></div><button type="button" class="mhks-mini__x" aria-label="Mini-Vorschau schließen">✕</button>';
    mini.addEventListener('click', function (e) {
      if (e.target.closest('.mhks-mini__x')) { e.stopPropagation(); miniOff = true; ss('mhKonfMiniOff', '1'); mini.classList.remove('on'); return; }
      var a = active(), cfg = a && MINI[a.key], box = cfg && a.root.querySelector(cfg.box);
      if (!box) return;
      if (a.root.closest('.mhtk-modal__dialog')) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollTo({ top: Math.max(0, window.pageYOffset + box.getBoundingClientRect().top - headerH() - 12), behavior: 'smooth' });
    });
    document.body.appendChild(mini);
    return mini;
  }
  function miniFill(src) {
    var host = mini.querySelector('.mhks-mini__img');
    var cands = src.querySelectorAll('svg,canvas'), el = null;
    for (var i = 0; i < cands.length; i++) { var r = cands[i].getBoundingClientRect(); if (r.width > 80 && r.height > 40 && (!el || r.width * r.height > el.w)) el = { n: cands[i], w: r.width * r.height }; }
    if (!el) return;
    el = el.n;
    if (el.tagName.toLowerCase() === 'canvas') {
      var c = host.querySelector('canvas');
      if (!c) { host.innerHTML = ''; c = document.createElement('canvas'); host.appendChild(c); }
      var k = Math.min(1, 480 / (el.width || 1));
      c.width = Math.max(1, Math.round(el.width * k)); c.height = Math.max(1, Math.round(el.height * k));
      try { c.getContext('2d').drawImage(el, 0, 0, c.width, c.height); } catch (e) {}
    } else {
      var cl = el.cloneNode(true);
      cl.removeAttribute('id'); cl.removeAttribute('width'); cl.removeAttribute('height'); cl.style.cssText = '';
      if (!cl.getAttribute('viewBox')) { var bb = el.getBoundingClientRect(); cl.setAttribute('viewBox', '0 0 ' + bb.width + ' ' + bb.height); }
      cl.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      host.innerHTML = ''; host.appendChild(cl);
    }
  }
  /* Hoehe des mitlaufenden Seitenkopfs (im PopUp 0) - die Mini-Vorschau sitzt oben mittig darunter */
  function headerH() {
    var hb = 0;
    [].forEach.call(document.querySelectorAll('sticky-header,header,.header,.header-wrapper,[id^="shopify-section"][id*="header"]'), function (h) {
      if (h.closest('.mhtk-modal')) return;
      var r = h.getBoundingClientRect(); if (r.height < 20 || r.height > 260 || r.bottom <= 0 || r.top > 4) return;
      var p = getComputedStyle(h).position, stuck = p === 'fixed' || p === 'sticky' || (h.parentElement && /fixed|sticky/.test(getComputedStyle(h.parentElement).position));
      if (stuck) hb = Math.max(hb, r.bottom);
    });
    return Math.round(hb);
  }
  /* 02.10.2026: nicht im Warenkorb (Seite oder seitlicher Warenkorb) und nicht ueber anderen offenen Fenstern */
  function overlayOpen() {
    if (/^\/cart(\/|$)/.test(location.pathname)) return true;
    var list = document.querySelectorAll('cart-drawer,.cart-drawer,.drawer,menu-drawer,.menu-drawer,[aria-modal="true"],.modal[open],dialog[open]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.hasAttribute('hidden') || el.hasAttribute('inert') || (el.closest && el.closest('.mhtk-modal,.mhks-mini'))) continue;
      /* Schubladen (Warenkorb, Menue) bleiben nach dem Schliessen im DOM - offen nur mit "open" */
      if (/drawer/i.test(el.tagName + ' ' + el.className) && !el.hasAttribute('open') && !/(^|\s)(open|active|is-open)(\s|$)/.test(el.className)) continue;
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity < 0.05) continue;
      if (r.width < 60 || r.height < 60 || r.right <= 2 || r.left >= window.innerWidth - 2 || r.bottom <= 2 || r.top >= window.innerHeight - 2) continue;
      return true;
    }
    return false;
  }
  function miniPad(px) {   /* angetippte Eingabefelder scrollt der Browser unter die Leiste, nicht dahinter */
    var v = px ? px + 'px' : '';
    if (document.documentElement.style.scrollPaddingTop !== v) document.documentElement.style.scrollPaddingTop = v;
  }
  function miniCheck() {
    miniRaf = 0;
    /* 12.10.2026: Mini-Vorschau nur noch am Handy/Tablet (bis 989 px, gleiche Grenze wie das
       mobile Layout der Leiste). Am Desktop ist die Zeichnung ohnehin gross im Bild. */
    if (window.innerWidth > 989) { if (mini) mini.classList.remove('on'); miniPad(0); return; }
    if (miniOff || ss('mhKonfMiniOff') || overlayOpen()) { if (mini) mini.classList.remove('on'); miniPad(0); return; }
    var a = active(), cfg = a && MINI[a.key], box = cfg && a.root.querySelector(cfg.box);
    var show = false;
    if (box && shown(box) && !document.querySelector('.mhks-ov:not(.mhks-ov--inline),.mhdx-ov,.plan-modal.open,.plan-modal.is-open')) {
      var inModal = !!a.root.closest('.mhtk-modal__dialog'), top0 = inModal ? 0 : headerH();
      var rb = box.getBoundingClientRect(), rr = a.root.getBoundingClientRect();
      show = rb.bottom < top0 + 40 && rr.bottom > window.innerHeight * 0.35;
    }
    if (!show) { if (mini) mini.classList.remove('on'); miniPad(0); return; }
    miniEl();
    mini.style.setProperty('--mhks-mini-top', (top0 + 10) + 'px');
    miniPad(!inModal && window.innerWidth <= 989 ? top0 + 10 + (mini.offsetHeight || 66) + 10 : 0);
    var now = Date.now();
    if (miniKey !== a.key || now - miniT > 900) { miniKey = a.key; miniT = now; miniFill(a.root.querySelector(cfg.src) || box); }
    mini.classList.add('on');
  }
  function miniSoon() { if (!miniRaf) miniRaf = setTimeout(miniCheck, 60); }   /* setTimeout statt requestAnimationFrame: laeuft auch, wenn der Tab kurz im Hintergrund war */
  /* capture: faengt auch das Scrollen im Konfigurator-PopUp der Produktseite (dort scrollt der Dialog, nicht die Seite) */
  document.addEventListener('scroll', miniSoon, { passive: true, capture: true });
  window.addEventListener('resize', miniSoon, { passive: true });
  document.addEventListener('click', function () { setTimeout(miniSoon, 350); setTimeout(miniSoon, 900); }, true);   /* z. B. Warenkorb geoeffnet */
  setInterval(function () { if (mini && mini.classList.contains('on')) { miniT = 0; miniSoon(); } }, 1500);

  /* ---------- 17. Preisleiste am Handy (02.10.2026) ----------
     Alle vier Konfiguratoren gleich: unten eine schmale Leiste mit Gesamtpreis (Streichpreis,
     Ersparnis) und "Weiter" bzw. im letzten Schritt "In den Warenkorb". Sie erscheint nur, wenn
     die Kopfzeile mit dem Preis nicht im Bild ist, und nie bei offener Tastatur oder ueber
     Fenstern (Warenkorb, 3D, Speichern ...). Der Knopf loest den Knopf des Konfigurators aus. */
  var PBAR = {
    wpc: { head: '.canvas-top', next: '.nav button.btn-primary:not(#addCart)', cta: '#addCart', steps: '.stepper' },
    terrassen: { head: '.canvas-top', next: '.nav button.btn-primary:not(#addCart)', cta: '#addCart', steps: '.stepper' },
    zaun: { head: '.mhks-top', next: '.mhzk-nav__next', cta: '.mhzk__cta', steps: '.mhzk-steps' },
    doppelstab: { head: '.mhks-top', next: '.mhds-next', cta: '.mhds-cta', steps: '.mhds-steps' }
  };
  var pbar = null, pbarT = 0, pbarTarget = null;
  function vis(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); }
  function firstVis(root, sel) { var l = root.querySelectorAll(sel); for (var i = 0; i < l.length; i++) if (vis(l[i])) return l[i]; return null; }
  function pbarPrice(key, root) {
    var ad = adapters[key], inf = null;
    if (TOP[key]) { try { inf = TOP[key].info(root, ad); } catch (e) { inf = null; } return inf ? { price: inf.price || 0, cap: inf.cap || 0 } : null; }
    var tv = root.querySelector('#totalVal'); if (!tv) return null;
    var cv = root.querySelector('#cmpVal'), row = root.querySelector('#cmpRow');
    return { price: cents(txt(tv)), cap: cv && (!row || row.style.display !== 'none') ? cents(txt(cv)) : 0 };
  }
  function typing() {
    var a = document.activeElement;
    if (!a || !a.tagName) return false;
    if (a.tagName === 'TEXTAREA' || a.isContentEditable) return true;
    if (a.tagName === 'SELECT') return true;
    return a.tagName === 'INPUT' && !/^(range|checkbox|radio|button|submit|color|file)$/i.test(a.type || '');
  }
  function pbarEl() {
    if (pbar) return pbar;
    ensureCss();
    pbar = document.createElement('div');
    pbar.className = 'mhks-pbar'; pbar.setAttribute('role', 'region'); pbar.setAttribute('aria-label', 'Preis und nächster Schritt');
    pbar.innerHTML = '<div class="mhks-pbar__p"><small>Gesamt inkl. MwSt.</small><span><s hidden></s><b></b></span><em hidden></em></div><button type="button" class="mhks-pbar__go"></button>';
    pbar.querySelector('.mhks-pbar__go').addEventListener('click', function () {
      var t = pbarTarget; if (!t || t.disabled) return;
      var isNext = !t.matches(PBAR_CTA);
      t.click();
      if (!isNext) return;
      setTimeout(function () {   /* nach "Weiter" an den Anfang des neuen Schritts */
        var a = active(), cfg = a && PBAR[a.key]; if (!cfg) return;
        var st = a.root.querySelector(cfg.steps) || a.root, r = st.getBoundingClientRect(), dlg = a.root.closest('.mhtk-modal__dialog');
        if (dlg) { var dr = dlg.getBoundingClientRect(); if (r.top < dr.top || r.top > dr.top + dlg.clientHeight * 0.5) dlg.scrollTop += r.top - dr.top - 10; return; }
        var top0 = headerH();
        if (r.top < top0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - top0 - 12), behavior: 'smooth' });
      }, 120);
    });
    document.body.appendChild(pbar);
    return pbar;
  }
  var PBAR_CTA = Object.keys(PBAR).map(function (k) { return PBAR[k].cta; }).join(',');
  function pbarOff() { if (pbar) pbar.classList.remove('on'); document.documentElement.classList.remove('mhks-pbar-on'); }
  function pbarCheck() {
    pbarT = 0;
    if (window.innerWidth > 989) { pbarOff(); return; }
    var a = active(), cfg = a && PBAR[a.key];
    if (!cfg || typing() || overlayOpen()) { pbarOff(); return; }
    var dlg = a.root.closest('.mhtk-modal__dialog');
    if (!dlg && document.querySelector('.mhtk-modal.is-open')) { pbarOff(); return; }
    var blocks = document.querySelectorAll('.mhks-ov:not(.mhks-ov--inline),.mhdx-ov,.mhzk-ov,.plan-modal.open,.plan-modal.is-open,#tpArSheet,#arSheet,.mh-ar-overlay');
    for (var i = 0; i < blocks.length; i++) if (vis(blocks[i]) && getComputedStyle(blocks[i]).display !== 'none') { pbarOff(); return; }
    var vh = window.innerHeight, top0 = dlg ? dlg.getBoundingClientRect().top : headerH();
    var rr = a.root.getBoundingClientRect();
    if (rr.bottom < vh * 0.45 || rr.top > vh - 120) { pbarOff(); return; }   /* Konfigurator nicht mehr im Bild */
    var head = firstVis(a.root, cfg.head);
    if (head) { var hr = head.getBoundingClientRect(); if (hr.bottom > top0 + 8 && hr.top < vh - 80) { pbarOff(); return; } }
    var pr = pbarPrice(a.key, a.root);
    if (!pr || !pr.price) { pbarOff(); return; }
    var el = pbarEl();
    setT(el.querySelector('b'), eur(pr.price));
    var sEl = el.querySelector('s'), em = el.querySelector('em'), sv = pr.cap > pr.price ? pr.cap - pr.price : 0;
    sEl.hidden = !sv; setT(sEl, sv ? eur(pr.cap) : '');
    em.hidden = !sv; setT(em, sv ? 'Sie sparen ' + eur(sv) : '');
    var nx = firstVis(a.root, cfg.next), cta = nx ? null : firstVis(a.root, cfg.cta), go = el.querySelector('.mhks-pbar__go');
    pbarTarget = nx || cta;
    go.hidden = !pbarTarget;
    if (pbarTarget) { setT(go, nx ? 'Weiter' : 'In den Warenkorb'); go.disabled = !!pbarTarget.disabled; }
    el.classList.add('on');
    document.documentElement.classList.add('mhks-pbar-on');
  }
  function pbarSoon() { if (!pbarT) pbarT = setTimeout(pbarCheck, 80); }
  document.addEventListener('scroll', pbarSoon, { passive: true, capture: true });
  window.addEventListener('resize', pbarSoon, { passive: true });
  ['click', 'input', 'change', 'focusin', 'focusout'].forEach(function (ev) { document.addEventListener(ev, function () { pbarSoon(); setTimeout(pbarSoon, 400); }, true); });
  setInterval(pbarSoon, 1200);

  /* ---------- 12. Kopfzeile wie WPC (Sichtschutz, Doppelstab) ---------- */
  function cents(txt) {   /* "1.234,56 €" -> 123456 */
    var m = String(txt || '').replace(/\s/g, '').match(/-?[\d.]+(,\d+)?/);
    if (!m) return 0;
    return Math.round(parseFloat(m[0].replace(/\./g, '').replace(',', '.')) * 100) || 0;
  }
  var EURF = (window.Intl && Intl.NumberFormat) ? new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' }) : null;
  function eur(c) { var e = (c || 0) / 100; return EURF ? EURF.format(e) : e.toFixed(2).replace('.', ',') + ' €'; }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function setT(el, v) { if (el && el.textContent !== v) el.textContent = v; }   /* nur bei Aenderung - sonst Endlosschleife mit dem MutationObserver */
  var TOP = {
    doppelstab: { host: '.mhds-preview', tools: '.mhds-tools',
      info: function (root, ad) { return ad && ad.top ? ad.top() : null; } },
    zaun: { host: '.mhzk-app__preview', tools: '.mhzk-tools',
      info: function (root, ad) {
        var fin = root.querySelector('[data-mhzk-final]'); if (!fin || !txt(fin)) return null;
        var li = root.querySelector('[data-mhzk-list]'), prof = txt(root.querySelector('[data-mhzk-profil-name]'));
        var sm = ''; try { sm = ad && ad.summary ? ad.summary() : ''; } catch (e) {}
        var img = root.querySelector('.mhzk__profile.is-active img,[data-mhzk-profile] .is-active img,.mhzk__swatch.is-active img');
        return { img: img ? (img.currentSrc || img.src) : '', title: 'Sichtschutzzaun' + (prof ? ' · ' + prof : ''),
          stats: String(sm).split(/ · |, /).filter(function (x) { return x && !/€/.test(x) && !/^Sichtschutzzaun$/i.test(x); }).slice(0, 3).join(' · '), price: cents(txt(fin)), cap: li && !li.hidden ? cents(txt(li)) : 0 };
      } }
  };
  function updTops() {
    Object.keys(TOP).forEach(function (key) {
      var cfg = TOP[key], roots = document.querySelectorAll(KONF[key].root);
      [].forEach.call(roots, function (root) {
        var host = root.querySelector(cfg.host); if (!host) return;
        var bar = host.querySelector(':scope > .mhks-top');
        if (!bar) {
          bar = document.createElement('div'); bar.className = 'mhks-top';
          bar.innerHTML = '<span class="mhks-top__img"></span><div class="mhks-top__t"><b></b><small></small></div><div class="mhks-top__p"><small>Gesamt inkl. MwSt.</small><s hidden></s><b></b></div><div class="mhks-top__tools"></div>';
          host.insertBefore(bar, host.firstChild);
        }
        var tools = root.querySelector(cfg.tools);
        if (tools && tools.parentNode !== bar.querySelector('.mhks-top__tools')) bar.querySelector('.mhks-top__tools').appendChild(tools);
        var inf = null; try { inf = cfg.info(root, adapters[key]); } catch (e) { inf = null; }
        if (!inf) return;
        var im = bar.querySelector('.mhks-top__img');
        if (inf.img) im.style.backgroundImage = 'url("' + inf.img.replace(/"/g, '') + '")';
        im.hidden = !inf.img;
        bar.style.gridTemplateColumns = inf.img ? '' : 'minmax(0,1fr) auto';
        setT(bar.querySelector('.mhks-top__t b'), inf.title || '');
        setT(bar.querySelector('.mhks-top__t small'), inf.stats || '');
        var sEl = bar.querySelector('.mhks-top__p s'); sEl.hidden = !(inf.cap > inf.price); setT(sEl, inf.cap > inf.price ? eur(inf.cap) : '');
        setT(bar.querySelector('.mhks-top__p b'), inf.price ? eur(inf.price) : '…');
      });
    });
  }

  /* ---------- 13. Dein Set steht ---------- */
  function bomRows(root) {   /* WPC + Terrassen: Positionen aus der Materialliste lesen */
    return [].map.call(root.querySelectorAll('#bom .bom-row'), function (r) {
      var q = r.querySelector('.bqty'), u = r.querySelector('.bqrow');
      var unit = u ? txt(u).replace(/^[\d.,\s]+/, '') : '';
      return { qty: q ? q.value : '', unit: unit, title: txt(r.querySelector('.bom-main b')), sub: txt(r.querySelector('.bom-main span')) };
    }).filter(function (x) { return x.title && +x.qty > 0; });
  }
  function kurzTitel(t) { return String(t || '').replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim(); }
  var SET = {
    doppelstab: { before: '[data-r="bom"]', data: function (root, ad) { return ad && ad.set ? ad.set() : null; } },
    wpc: { before: '#bom', hideSum: '.summary', data: function (root) { return domSet(root, 'Mengen auf Ihre Fläche gerechnet'); } },
    terrassen: { before: '#bom', hideSum: '.summary', data: function (root) { return domSet(root, 'Mengen auf Ihre Fläche gerechnet'); } },
    zaun: { before: '[data-mhzk-setwrap]', data: function (root) {
      var fin = root.querySelector('[data-mhzk-final]'); if (!fin || !txt(fin)) return null;
      var li = root.querySelector('[data-mhzk-list]'), items = [].map.call(root.querySelectorAll('[data-mhzk-setlist] li'), function (x) {
        var q = txt(x.querySelector('b')), n = txt(x.querySelector('span'));
        return n ? [q ? q.replace(/\s*[×x]\s*$/, '×') : '', n] : null;
      }).filter(Boolean);
      var f = items.slice(0, 4);
      return { price: cents(txt(fin)), cap: li && !li.hidden ? cents(txt(li)) : 0, facts: f, n: items.length };
    } }
  };
  function domSet(root, last) {
    var tv = root.querySelector('#totalVal'); if (!tv) return null;
    var price = cents(txt(tv)), cv = root.querySelector('#cmpVal'), row = root.querySelector('#cmpRow');
    var cap = cv && (!row || row.style.display !== 'none') ? cents(txt(cv)) : 0;
    var rows = bomRows(root); if (!rows.length || !price) return null;
    var f = rows.slice(0, 4).map(function (r) { return [r.qty + ' ' + r.unit, kurzTitel(r.title)]; });
    var area = txt(root.querySelector('#areaVal'));
    if (area && area !== '—') f.push([area, last]);
    return { price: price, cap: cap, facts: f, n: rows.length };
  }
  function aktion(key) {
    var a = window.MH_KONF_AKTION && window.MH_KONF_AKTION[key];
    if (!a || !a.code || !a.pct) return '';
    var end = +a.end || Date.parse(a.end) || 0;
    if (end && end < Date.now()) return '';
    var bis = end ? new Date(end).toLocaleDateString('de-AT', { day: '2-digit', month: '2-digit' }) : '';
    return '<div class="mhks-set__ak"><b>Aktion:</b> Mit dem Code <b>' + esc(a.code) + '</b> sparen Sie im Warenkorb zusätzlich ' + esc(a.pct) + ' %' + (bis ? ' – nur bis ' + esc(bis) : '.') + '</div>';
  }
  function updSets() {
    Object.keys(SET).forEach(function (key) {
      var cfg = SET[key];
      [].forEach.call(document.querySelectorAll(KONF[key].root), function (root) {
        var anchor = root.querySelector(cfg.before); if (!anchor) return;
        var d = null; try { d = cfg.data(root, adapters[key]); } catch (e) { d = null; }
        var card = root.querySelector('.mhks-set');
        if (!d || !d.price) { if (card) card.hidden = true; return; }
        if (!card) {
          card = document.createElement('div'); card.className = 'mhks-set';
          card.innerHTML = '<div class="mhks-set__in"></div><button type="button" class="mhks-set__t" aria-expanded="false"><span></span><i>+</i></button>';
          anchor.parentNode.insertBefore(card, anchor);
          card.querySelector('.mhks-set__t').addEventListener('click', function () {
            var open = !root.classList.contains('mhks-bom-open');
            root.classList.toggle('mhks-bom-open', open);
            var w = root.querySelector('[data-mhzk-setwrap]'); if (w && open) w.open = true;
            this.setAttribute('aria-expanded', String(open));
            this.querySelector('i').textContent = open ? '–' : '+';
            this.querySelector('span').textContent = (open ? 'Stückliste ausblenden' : 'Stückliste anzeigen') + (card.__n ? ' (' + card.__n + ' Positionen)' : '');
          });
          if (cfg.hideSum) { var hs = root.querySelector(cfg.hideSum); if (hs) hs.classList.add('mh-konf-sumhide'); }
        }
        card.hidden = false;
        root.classList.add('mhks-has-set');
        var cap = d.cap > d.price ? d.cap : 0, pct = cap ? Math.round((1 - d.price / cap) * 100) : 0;
        var html = '<div class="mhks-set__h"><b>Ihr Set steht</b><span class="mhks-set__pr">' + (cap ? '<s>' + eur(cap) + '</s>' : '') + '<b>' + eur(d.price) + '</b></span></div>' +
          (cap && pct >= 1 ? '<div class="mhks-set__sv">' + pct + ' % unter UVP · ' + eur(cap - d.price) + ' gespart</div>' : '') +
          aktion(key) +
          '<ul class="mhks-set__l">' + (d.facts || []).map(function (f) { return '<li><b>' + esc(f[0]) + '</b><span>' + esc(f[1] || '') + '</span></li>'; }).join('') + '</ul>';
        var inn = card.querySelector('.mhks-set__in');
        if (inn.__h !== html) { inn.innerHTML = html; inn.__h = html; }
        card.__n = d.n || 0;
        var open = root.classList.contains('mhks-bom-open'), sp = card.querySelector('.mhks-set__t span');
        setT(sp, (open ? 'Stückliste ausblenden' : 'Stückliste anzeigen') + (card.__n ? ' (' + card.__n + ' Positionen)' : ''));
      });
    });
  }
  var setQ = false;
  function setsSoon() { if (setQ) return; setQ = true; setTimeout(function () { setQ = false; try { updTops(); updSets(); } catch (e) {} }, 120); }
  document.addEventListener('input', setsSoon, true);
  document.addEventListener('click', setsSoon, true);
  setInterval(setsSoon, 2500);

  /* ---------- 18. Automatisches Speichern am letzten Schritt (anonym, 28.10.2026) ----------
     Erreicht der Kunde den letzten Schritt ("Dein Set steht" / Zusammenfassung), geht die Konfiguration
     einmal im Hintergrund an POST {MH_LINK_API}/snap - OHNE Kundendaten (keine E-Mail, keine PLZ, kein
     Name, kein Cookie). Zweck: Auswertung, welche Konfigurationen am haeufigsten gebaut werden.
       - entprellt (2 s) und dedupliziert (Hash der Konfiguration, je Sitzung in sessionStorage)
       - Session-Kennung (zufaellig, nur sessionStorage) nur mit Statistik-Einwilligung (Cookiebot
         "statistics" bzw. Shopify Customer Privacy analyticsProcessingAllowed); sonst ohne Kennung
       - "In den Warenkorb" aus demselben Konfigurator setzt am letzten Eintrag das Flag in_cart
       - Ziel: EP_KONF_CFG.snap, sonst EP_KONF_CFG.link; beides leer -> es wird nichts gesendet. Fehler bleiben
         still (nach 2 Fehlern Stopp fuer diese Seite)
       - Pergola meldet sich per Event  document.dispatchEvent(new CustomEvent('mh:konf:final',
         { detail: { key: 'pergola', final: true, data: {...} } }))  (assets/ep-pergola.js); die
         anderen vier erkennt die Suite ueber die Schrittleiste (letzter Schritt aktiv) + Set-Karte,
         koennen aber ebenfalls 'mh:konf:final' mit detail.key schicken.
     Test: window.MH_SNAP_TEST = function (payload) {...} ersetzt den Versand (analog MH_KLAVIYO_TEST). */
  var SNAP_SHOP = 'englputzeder';
  /* EP: Ziel aus EP_KONF_CFG.snap, sonst EP_KONF_CFG.link (= LINK_API). Beides leer -> kein Versand. */
  var SNAP_API = String(CFG.snap || LINK_API || '').trim().replace(/\/+$/, '');
  var SNAP_STEP = { wpc: ':scope > .stepper .step', terrassen: ':scope > .stepper .step', zaun: '.mhzk-step', doppelstab: '.mhds-step' };
  var SNAP_KEYS = KEYS.concat(['pergola']);
  var snapLast = {}, snapId = {}, snapEvt = {}, snapT = null, snapFails = 0, snapFirst = {}, snapSeen = {};
  try { snapSeen = JSON.parse(ss('mhSnapSeen') || '{}') || {}; } catch (e) { snapSeen = {}; }

  function analyticsOk() {
    try {
      var cb = window.Cookiebot, sp = window.Shopify && window.Shopify.customerPrivacy;
      if (cb && cb.consent) return cb.consent.statistics === true;
      if (sp && typeof sp.analyticsProcessingAllowed === 'function') return sp.analyticsProcessingAllowed() === true;
    } catch (e) {}
    return false;
  }
  function snapSid() {   /* zufaellige Sitzungs-Kennung, kein Fingerprint, nur sessionStorage */
    if (!analyticsOk()) return '';
    var s = ss('mhSnapSid');
    if (s && /^[a-z0-9]{10,24}$/.test(s)) return s;
    s = '';
    try { var a = new Uint32Array(3); window.crypto.getRandomValues(a); for (var i = 0; i < 3; i++) s += a[i].toString(36); } catch (e) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); }
    s = s.slice(0, 24);
    ss('mhSnapSid', s);
    return s;
  }
  function snapHash(str) {   /* FNV-1a 32 Bit, reicht fuer Dedupe */
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return ('0000000' + h.toString(16)).slice(-8);
  }
  /* Sicherheitsnetz: alles, was nach Personendaten aussieht, fliegt raus (Schluessel + E-Mail-Muster) */
  var SNAP_PII_KEY = /mail|plz|zip|postleitzahl|name|vorname|nachname|tel|phone|fon|adresse|address|street|strasse|kunde|customer|ip$|^_m$/i;
  function snapClean(v, depth) {
    depth = depth || 0;
    if (depth > 8) return undefined;
    if (v == null) return v;
    if (typeof v === 'string') return /@/.test(v) ? '' : v.slice(0, 200);
    if (typeof v === 'number' || typeof v === 'boolean') return v;
    if (Array.isArray(v)) return v.slice(0, 400).map(function (x) { return snapClean(x, depth + 1); });
    if (typeof v === 'object') {
      var o = {};
      Object.keys(v).forEach(function (k) {
        if (SNAP_PII_KEY.test(k) && !/^(titel|title|label|modell|mt|m|n)$/.test(k)) return;
        var c = snapClean(v[k], depth + 1);
        if (c !== undefined) o[k] = c;
      });
      return o;
    }
    return undefined;
  }
  function snapSteps(key, root) {
    var st = [];
    try { st = root.querySelectorAll(SNAP_STEP[key]); } catch (e) { st = []; }
    for (var n = root.parentElement, d = 0; !st.length && n && d < 4; n = n.parentElement, d++) {
      try { st = n.querySelectorAll(SNAP_STEP[key].replace(':scope > ', '')); } catch (e) { st = []; }
    }
    return st;
  }
  /* letzter Schritt erreicht? Schrittleiste (aktiv = letzter), sonst sichtbare Set-Karte, sonst Event */
  function snapFinal(key, root) {
    if (snapEvt[key] && Date.now() - snapEvt[key] < 15000) return true;
    if (!root) return false;
    var st = snapSteps(key, root), act = -1;
    for (var j = 0; j < st.length; j++) if (st[j].classList.contains('active') || st[j].classList.contains('is-active')) act = j;
    if (st.length) return act === st.length - 1;
    var card = root.querySelector('.mhks-set');
    return !!(card && !card.hidden && shown(card));
  }
  function snapRows(key, root, ad) {   /* Stueckliste so, wie die Set-Karte sie liest */
    try {
      if (key === 'wpc' || key === 'terrassen') return bomRows(root).map(function (r) { return { titel: kurzTitel(r.title), info: r.sub, menge: +String(r.qty).replace(',', '.') || r.qty, einheit: r.unit }; });
      if (key === 'zaun') return [].map.call(root.querySelectorAll('[data-mhzk-setlist] li'), function (x) {
        var q = txt(x.querySelector('b')), n = txt(x.querySelector('span')); return n ? { titel: n, menge: q.replace(/\s*[×x]\s*$/, '') } : null; }).filter(Boolean);
      if (key === 'doppelstab') { var s = ad && ad.set ? ad.set() : null; return s && s.facts ? s.facts.map(function (f) { return { menge: f[0], titel: f[1] }; }) : []; }
    } catch (e) {}
    return [];
  }
  function snapPayload(key, root, extra) {
    var ad = adapters[key], serial = null, summary = '', setd = null;
    if (key === 'pergola') {
      serial = extra || null;
    } else {
      try { serial = ad && ad.serialize ? ad.serialize() : null; } catch (e) { serial = null; }
      try { summary = ad && ad.summary ? String(ad.summary()) : ''; } catch (e) { summary = ''; }
      try { setd = SET[key] && root ? SET[key].data(root, ad) : null; } catch (e) { setd = null; }
    }
    if (!serial && !setd) return null;
    if (key !== 'pergola' && !(setd && setd.price)) return null;   /* ohne Set-Preis ist die Planung nicht fertig */
    var role = '';
    try { role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role || ''; } catch (e) {}
    var p = {
      v: 1,
      konfigurator: key,
      shop: SNAP_SHOP,
      theme_role: role === 'main' ? 'main' : 'preview',
      seite: window.location.pathname,
      geraet: window.matchMedia && window.matchMedia('(max-width: 989px)').matches ? 'mobil' : 'desktop',
      zusammenfassung: summary.slice(0, 300),
      preis: key === 'pergola' ? (serial && serial.preis) || 0 : (setd && setd.price) || 0,
      streichpreis: key === 'pergola' ? (serial && serial.streichpreis) || 0 : (setd && setd.cap) || 0,
      positionen: key === 'pergola' ? (serial && serial.positionen) || [] : snapRows(key, root, ad),
      positionen_n: key === 'pergola' ? ((serial && serial.positionen) || []).length : (setd && setd.n) || 0,
      serial: serial
    };
    if (snapFirst[key]) p.dauer_s = Math.round((Date.now() - snapFirst[key]) / 1000);
    var sid = snapSid(); if (sid) p.sid = sid;
    return snapClean(p);
  }
  function snapSend(p) {
    if (typeof window.MH_SNAP_TEST === 'function') { try { window.MH_SNAP_TEST(p); } catch (e) {} return Promise.resolve({ id: 'test' }); }
    if (!SNAP_API || !nativeFetch || snapFails >= 2) return Promise.resolve(null);
    /* text/plain wie beim Kurzlink (/s): kein CORS-Preflight; keepalive: kommt auch beim Weiterklicken an */
    return nativeFetch(SNAP_API + '/snap', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(p) })
      .then(function (r) { if (!r.ok) { snapFails++; return null; } snapFails = 0; return r.json().catch(function () { return null; }); })
      .catch(function () { snapFails++; return null; });
  }
  function snapCheck(key, root, extra, inCart) {
    var p = snapPayload(key, root, extra);
    if (!p) return;
    var h = snapHash(JSON.stringify({ k: key, s: p.serial, pr: p.preis, n: p.positionen_n }));
    if (!inCart && (snapLast[key] === h || snapSeen[h])) return;
    p.hash = h;
    if (inCart) { p.in_cart = true; if (snapId[key]) p.ref = snapId[key]; }
    snapLast[key] = h; snapSeen[h] = 1;
    try { var keep = Object.keys(snapSeen).slice(-60), o = {}; keep.forEach(function (k) { o[k] = 1; }); snapSeen = o; ss('mhSnapSeen', JSON.stringify(o)); } catch (e) {}
    snapSend(p).then(function (j) { if (j && j.id && /^[0-9A-Za-z_-]{6,40}$/.test(String(j.id))) snapId[key] = String(j.id); });
  }
  function snapRun() {
    snapT = null;
    KEYS.forEach(function (key) {
      var root = rootOf(key, true); if (!root) return;
      if (!snapFirst[key] && lastKonf === key) snapFirst[key] = lastKonfT || Date.now();
      if (snapFinal(key, root)) snapCheck(key, root);
    });
  }
  function snapSoon() { if (snapT) return; snapT = setTimeout(snapRun, 2000); }
  /* Warenkorb: aus der fetch-Huelle (Punkt 2) nach erfolgreichem /cart/add */
  function snapCart(key) {
    if (key === 'pergola') { if (snapEvt.pergola && snapEvt.pergolaData) snapCheck('pergola', null, snapEvt.pergolaData, true); return; }
    var root = rootOf(key, false); if (root) snapCheck(key, root, null, true);
  }
  document.addEventListener('mh:konf:final', function (e) {
    var d = e && e.detail || {}, key = d.key;
    if (SNAP_KEYS.indexOf(key) < 0) return;
    if (!snapFirst[key]) snapFirst[key] = Date.now();
    if (d.final === false) { snapEvt[key] = 0; return; }
    snapEvt[key] = Date.now();
    if (key === 'pergola') { snapEvt.pergolaData = d.data || null; if (snapT) clearTimeout(snapT); snapT = setTimeout(function () { snapT = null; if (snapEvt.pergolaData) snapCheck('pergola', null, snapEvt.pergolaData); snapRun(); }, 2000); return; }
    snapSoon();
  });
  document.addEventListener('mhkonf:dom', snapSoon);
  document.addEventListener('input', snapSoon, true);
  document.addEventListener('click', snapSoon, true);
  document.addEventListener('change', snapSoon, true);
  setInterval(function () { if (lastKonf && Date.now() - lastKonfT < 20000) snapSoon(); }, 4000);

  /* ---------- Anmeldung der Konfiguratoren ---------- */
  function register(key, ad) { if (key && ad) adapters[key] = ad; }
  var q = window.MHKonfQ || [];
  q.forEach(function (it) { register(it[0], it[1]); });
  window.MHKonfQ = { push: function (it) { register(it[0], it[1]); } };

  window.MHKonf = { register: register, info: info, infoMarkup: infoMarkup, active: active, config: KONF, openSave: openSave, openFeedback: openFeedback, feedbackInline: feedbackInline, planLink: planLink, toast: toast, _b64e: b64e, _b64d: b64d, _safeLink: safeLink, _marketingOk: marketingOk, refreshCart: refreshCart, cfg: CFG, _snapRun: snapRun, _snapPayload: snapPayload };

  /* ---------- Start ---------- */
  var injQ = false;
  function injSoon() { if (injQ) return; injQ = true; setTimeout(function () { injQ = false; injectCards(); injectEditLinks(); injectWa(); setsSoon(); try { document.dispatchEvent(new CustomEvent('mhkonf:dom')); } catch (e) {} }, 200); }
  function start() {
    injectCards();
    injectEditLinks();
    try { injectBadge(); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-mhks-feedback-inline]'), function (h) { feedbackInline(h, h.getAttribute('data-mhks-feedback-inline')); });
    if (window.MutationObserver) new MutationObserver(injSoon).observe(document.body, { childList: true, subtree: true });
    restoreFromUrl();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();